export default {
  SENDING: "Sendevorgang…",
  NOTHING_TO_SHOW: "Keine Elemente anzuzeigen",
  NO_ELEMENTS_FOUND: "Keine Elemente gefunden. Bitte präzisieren Sie Ihre Suchbegriffe.",
  VALUE_ADDED: "Wertschöpfungsprozess",
  NOT_VALUE_ADDED: "Anderer Prozess",
  VIDEO_HOVER: "Schau Video",
  BACK: "Zurück",
  CLOSE: "Schließen",
  CANCEL: "Abbrechen",
  YES: "Yes",
  ABORT: "Abbrechen",
  CONFIRM: "Bestätigen",
  REFRESH: "Aktualisieren",
  RESTORE: "Wiederherstellen",
  ARCHIVE: "Archivieren",
  NEXT: "Nächste",
  VACATION: "Urlaub",
  SETTINGS: "Einstellungen",
  SEARCH: "Suche",
  CLIENT: "Mandant",
  CLIENTS: "Mandanten",
  PROJECT: "Projekt",
  CLIENTS_GROUPS: "Mandantengruppen",
  INTERRUPT_SIDEBAR: "Unterbrechungen",
  USERS_SIDEBAR: "Benutzer",
  PROFIT_CENTERS_SIDEBAR: "Profit-Center",
  REPORTS_SIDEBAR: "Reports",
  API_SIDEBAR: "API keys",
  LICENSE_AGREEMENTS_SIDEBAR: "Lizenzvereinbarungen",
  SERVICE_LINE: "Geschäftsfeld",
  PROCESS_GROUP: "Prozessgruppe",
  PROCESS_GROUPS: "Prozessgruppen",
  ALL: "All",
  SELECT_ALL: "Alle auswählen",
  PROCESS: "Prozess",
  INTERRUPT: "Unterbrechung",
  INTERRUPTION: "Unterbrechung",
  INTERRUPTIONS: "Unterbrechungen",
  ACTIONS: "Handlungen",
  ADD: "Hinzufügen",
  FILTER: "Filter",
  FILTERS: "Filter",
  SAVE: "Speichern",
  SAVING: "Speichervorgang…",
  SAVING_ERROR: "Speichern nicht möglich. Überprüfen Sie die Daten!",
  STARTED: "Speichervorgang…",
  RETRY: "Wiederholen",
  FINISHED: "OK",
  ERROR: "Error",
  ERROR_DATA: "Error: ",
  ERROR_STATUS: "Error code: ",
  INVALID_TIME_FORMAT: "Falsches Format. Richtig: HH:MM:SS/X.X/Y,Y",
  INVALID_START_TIME_FORMAT: "Falsches Format. Richtig: HH:MM:SS",
  WORKLOG_OVERLAP_ERROR: "Dieses Worklog überschneidet sich mit einem anderen",
  NAME: "Bezeichnung",
  AT: "von",
  FROM: "vom",
  FOR_DATE: "für",
  TO_DATE: "an",
  OR: "oder",
  NA: "N/A",
  REQUIRED: "Dieses Feld ist auszufüllen",
  LOADING: "Ladevorgang…",
  ERROR_LOADING_DATA: "Fehler beim Laden der Daten - Versuchen Sie, die Seite zu aktualisieren. (Windows: Ctrl + F5, OSX: ⌘ + R)",
  PRINT: "Drucken",
  SUBMIT: "Absenden",
  OK: "OK",
  UPDATE: "Aktualisieren",
  UPDATE_ALL: "Alle aktualisieren",
  DELETE: "Löschen",
  RESUME: "Fortsetzen",
  TOGGLE_BACKGROUND: "Hintergrundfarbe umschalten/wechseln",
  ADMIN: "Admin",
  MANAGER: "Manager",
  CONNECTION_ERROR: "Probleme mit der Verbindung. Überprüfen Sie den Status Ihrer Internetverbindung.",
  OFFER_CALCULATOR: "Angebot Rechner",
  SUM: "Summe",
  WEEK: "Woche",
  WEEK_OF: "Woche",
  MONTH_BY_MONTH: "Monat für Monat",
  SELECTED_TIME_RANGE: "Ausgewählten Zeitbereich:",
  CHANGE: "Ändern",
  APPLY: "Anwenden",
  CLEAR: "Löschen",
  VIEW: "Ansehen",
  EDIT: "Bearbeiten",
  CONNECTION_TOO_SLOW: "Ihre Verbindung ist zu langsam. Bitteprüfen Sie Ihre Internetverbindung.",
  MONTHS: {
    JANUARY: "01 - January",
    FEBRUARY: "02 - Februar",
    MARCH: "03 - März",
    APRIL: "04 - April",
    MAY: "05 - Mai",
    JUNE: "06 - Juni",
    JULY: "07 - Juli",
    AUGUST: "08 - August",
    SEPTEMBER: "09 - September",
    OCTOBER: "10 - Oktober",
    NOVEMBER: "11 - November",
    DECEMBER: "12 - Dezember",
    JAN: "Jan",
    FEB: "Feb",
    MAR: "März",
    APR: "Apr",
    MAY_SHORT: "Mai",
    JUN: "Juni",
    JUL: "Juli",
    AUG: "Aug",
    SEP: "Sept",
    OCT: "Okt",
    NOV: "Nov",
    DEC: "Dez"
  },
  VA: {
    TRUE: "VA",
    FALSE: "NVA"
  },
  I18N: {
    LANGUAGES: "Sprachen",
    SWITCH_TO_ENGLISH: "Switch to English",
    SWITCH_TO_GERMAN: "Umschalten auf Deutsch"
  },
  TERMS_OF_USE: {
    TITLE: "Nutzungsbedingungen",
    ACCEPT: "Nutzungsbedingungen akzeptieren",
    EN: "English",
    PL: "Polski",
    DE: "Deutsche",
    VERSION: "v.",
    ERROR: "Etwas ist schief gelaufen! Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an den Administrator."
  },
  DOCUMENTATION: {
    TITLE: "Dokumentationszentrum"
  },
  WORKLOG_VALIDATION_ERRORS: {
    DOESNOTSTARTANDENDINDIFFERENTPROCESS: "Endet im nächsten Prozess",
    HASNOPROCESSINSIDE: "Hat Prozess im Inneren",
    DOESNOTSTARTORENDININTERRUPT: "Beginnt oder endet in einer Unterbrechung",
    ENDSBEFORESTART: "Endet früher als es beginnt",
    DOESNOTSTARTORENDINPROCESS: "Beginnt oder endet in einem anderen Prozess",
    NOTENDSINTHEFUTURE: "Endet in der Zukunft",
    ISVALIDSTARTFORMAT: "Startzeit ungültig",
    ISVALIDENDFORMAT: "Endzeit ungültig",
    VOLUME: "Die Menge muss größer oder gleich 0 sein"
  },
  WORK_DATA: {
    WORK_DATA: "Mitarbeiter - Ansicht",
    EXPORT: "Export",
    EXPORT_DATA: "Datenexport",
    BACK_TO_REPORTING: "Zurück zu Berichterstattung",
    SELECTED_DATES: "Datum auswählen",
    SELECTED_DAY: "Tag auswählen",
    SELECT_DATE_PLACEHOLDER: "Datum auswählen",
    FROM: "von",
    TO: "bis",
    SAVE: "Speichern",
    DURATION: "Dauer",
    DURATION_WITH_INVOICED_TIME: "Dauer / Fakturierte Zeit",
    VOLUME: "Menge",
    VOLUME_LONG: "Menge",
    VA: "Wertschöpfend",
    ADDED_MANUALLY: "Manuell hinzugefügt",
    ADDED_MANUALLY_LONG: "Manuell hinzugefügt",
    COMMENT: "Kommentar",
    INVOICE_DETAILS: "Rechnungs-Details",
    REPORTED_TIME: "Berichtete Zeit:",
    WORKNORM: "Arbeitsnorm:",
    STATS: "Stats",
    HOLIDAY: "Ferien",
    TIME_TODAY: "Heutige Zeit:",
    TIME: "Zeit:",
    REPORTED_TIME_PERCENT: "Verhältniszahl für die berichtete Zeit: ",
    PROCESS_GROUPS_AND_INTERRUPTS: "Prozessgruppen und Unterbrechungen",
    REPORTED_OVERTIME: "Überstunden gemeldet",
    ACCEPTED_OVERTIME: "Überstunden genehmigt",
    CUMULATED_OVERTIME: "Überstunden balance",
    USED_OVERTIME: "Überstunden genutzt:",
    REPORTED_REQUEST_OVERTIME: "Anfrage für Ueberstunden gemeldet:",
    TO_ACCEPT: "Akzeptieren",
    ACCEPTED: "Akzeptiert",
    UNSAVED_DATA_CHANGE_DATE_CONFIRMATION: "Sie haben keine Änderungen gespeichert. Möchten Sie die Daten wirklich ändern?",
    TEAM_LEADER_VIEW: "Teamleiter - Ansicht",
    FILTER_USERS: "Benutzer",
    FILTERS: "Filter",
    USERS: "Benutzer",
    D365_STATUSES: "D365 Status",
    ACCEPT: "Annehmen",
    ACCEPT_ALL: "Alles akzeptieren",
    EDIT: "Bearbeiten",
    EDIT_PROCESS_NOT_IN_WORKSPACE: "Dieser Worklog kann nicht bearbeitet werden — seine Prozesskonfiguration ist im aktuellen Workspace nicht mehr verfügbar.",
    EDIT_START_FAILED: "Dieser Worklog konnte nicht zur Bearbeitung geöffnet werden. Bitte versuchen Sie es erneut; falls das Problem weiterhin besteht, wenden Sie sich an das Support-Team.",
    DECLINE: "Löschen",
    DECLINE_OVERTIME: "Ablehnen",
    ADD_NEW_WORKLOG: "Neuen Worklog hinzufügen",
    SELECT_WORKLOG_TYPE: "Worklog Art auswählen:",
    SELECT_INTERRUPT: "Unterbrechung auswählen:",
    WORKLOG_TYPE: "Worklog Art:",
    SELECT_PROCESS: "Prozess auswählen:",
    START_DATE: "Datum",
    START_TIME: "Uhrzeitbeginn",
    END_TIME: "Endzeit",
    FINISH_TIME: "Uhrzeit - Ende",
    OVERLAP_ERROR: "Speichern nicht möglich. Überprüfen Sie die Prozesszeiten. Vergewissern Sie sich, dass sich die Prozesszeiten nicht überschneiden, und dass alle Unterbrechungen mit nur einem Prozess überlappen.",
    VACATION_ERROR: "Speichern nicht möglich. Überprüfen Sie die Daten. Vergewissern Sie sich, dass sich das 'von' Datum ist kleiner oder gleich 'an', und dass das 'von' Datum liegt nicht in der Vergangenheit.",
    VACATION_SUCCESS: "Sie haben den Urlaub erfolgreich gemeldet.",
    VACATION_DELETED: "Du hast den Urlaub gelöscht",
    DELETE_CONFIRMATION: "Sind Sie sicher, dass Sie diesen Arbeitseintrag löschen möchten?",
    LOT_OF_DATA: "Es könnten sehr viele Daten angezeigt werden.",
    LOT_OF_DATA_ACTION: "Daten anzeigen",
    SELECT_ALL: "Wählen Sie alles aus",
    GO_TO_DATE: "Gehe zu Datum",
    NAME: "Name",
    DATE: "Datum",
    PROCESS: "Process",
    TOTAL_ROWS: "Total rows",
    PROJECT: "Projekt",
    NO_PROJECT:"Kein Projekt",
    SELECT_COLUMNS: "Spalten",
    COLUMNS: "Spalten",
    TOGGLE_INACTIVITY_PERIODS: "Inaktivität",
    MANAGEMENT_MODE: "Mgmt. Modus",
    SYNCHRONIZE_WORKLOGS_STATUSES: "Status der Worklogs synchronisieren",
    RESEND: "Erneut senden",
    INVOICED_TIME: "Fakturierte Zeit",
    D365_STATUS: {
      SENT: "D365 - Gesendet",
      ERROR: "D365 - Gesendet, aber fehlgeschlagen. Kontaktieren Sie den Supportteam",
      PROCESSED: "D365 - Verarbeitet",
      PROCESSED_TO_KCP: "D365 - Verarbeitet, aber in KCP fehlgeschlagen",
      SENDING_ERROR: "D365 - Fehler beim Senden",
      AFTER_ACCEPT_SENT_SUCCESS: "Worklog akzeptiert und an D365 gesendet",
      AFTER_ACCEPT_SENT_SUCCESS_BUT_PROCESS_ERROR: "Worklog akzeptiert und an D365 gesendet, aber Verarbeitungsfehler aufgetreten",
      AFTER_ACCEPT_SENT_FAIL: "Worklog akzeptiert, aber nicht an D365 gesendet",
      AFTER_ACCEPT_SENT_FAIL_NO_MATCHING: "Worklog akzeptiert, aber aufgrund von Abgleichproblemen nicht an D365 gesendet",
      PROCESS_ERROR: "D365 - Prozessabgleich nicht gefunden",
      PROJECT_ERROR: "D365 - Projekt nicht gefunden",
      NO_D365_STATUS: "D365 Status nicht gefunden",
      DELETED: "D365 - Gelöscht"
    },
    VACATION: {
      VACATION: "Vacation",
      REPORT_VACATION: "Urlaub melden",
      REPORTED_VACATION: "Urlaub melden:",
      FROM: "Von",
      TO: "An",
      PROCESS_NAME: "Prozessbezeichnung",
      PROJECT_NAME: "Projekt",
      NAME: "Name",
      FROM_PLACEHOLDER: "2018-12-24",
      FROM_TOOLTIP: "Das Von-Datum muss kleiner oder gleich dem Bis-Datum sein. Das 'From'-Datum darf nicht in der Vergangenheit liegen.",
      TO_TOOLTIP: "Das Von-Datum muss kleiner oder gleich dem Bis-Datum sein.",
      DELETE_VACATION: "Urlaub löschen",
      INVALID_DATE_FROM: "VON muss nach heute sein",
      INVALID_DATE_TO: "AN muss nach heute und davor sein VON",
      MISSING_DATE_FROM: "VON darf nicht leer sein",
      MISSING_DATE_TO:"AN darf nicht leer sein",
      PICK_THE_HOUR:"Stunden auswählen",
      PICK_THE_PERCENTAGE:"Prozentsatz auswählen",
      SET_PERCENTAGES:"Prozentsatz festlegen:",
      FULL_TIME:"Vollzeit",
      FULL_TIME_VACATION:"Urlaub in Vollzeit",
      PART_TIME_VACATION:"Urlaub in Teilzeit",
      ERROR: "Einige Tage wurden aufgrund eines Nullwertes bei der Worknorm nicht hinzugefügt",
      SET_HOURS: "Stunden pro Tag einstellen"
    },
    VACATION_NOTES: {
      ALL_ZERO_WORKNORM: "Alle ausgewählten Tage hatten eine Arbeitszeit von 0 Stunden",
      OMITTING_HOLIDAYS: "Einige Feiertage wurden weggelassen, während Urlaub im ausgewählten Datumsbereich hinzugefügt wurden",
      WRONG_DATE: "Das 'Von'-Datum muss kleiner oder gleich dem 'Bis'-Datum sein und das 'Ab'-Datum darf nicht in der Vergangenheit liegen",
      VACATIONS_EXIST_IN_RANGE: "Urlaubstage im angegebenen Bereich sind bereits vorhanden",
      WORKLOG_VALIDATION_FAILED: "Sie haben heute berichtet",
      PROCESS_NOT_FOUND: "Dieser Prozess ist kein Urlaubsprozess oder der Prozess existiert überhaupt nicht",
      PROCESS_CONFIG_NOT_FOUND: "Eine solche Prozesskonfiguration existiert nicht",
      CLIENT_NOT_FOUND: "Es gibt keinen solchen Mandanten",
      ALL_DAYS_ARE_HOLIDAYS: "Alle ausgewählten Tage sind Feiertage",
      NO_FEATURE_FLAG: "Die Urlaubsfunktion ist für das Land des Benutzer nicht aktiviert",
      DAYS_WITH_EXCEEDED_TIME_1: "Der verfügbare Zeitbereich in ",
      DAYS_WITH_EXCEEDED_TIME_2: "(vom letzten Worklog bis Mitternacht) wurde überschritten. Bitte, Worklogs löschen und erneut versuchen."
    },
    POWER_USER: {
      IS_POWER_USER_TRUE: "Du bist ein Power User!",
      IS_POWER_USER_FALSE: "Du bist noch kein Power User.",
      LONG_TERM_USER_INFO: "„Du musst 120 Tage mit 95% der berichteten Zeit erreichen, um ein Power User zu sein.",
      LONG_TERM_USER_REPORTED: "Du hast berichtet",
      LONG_TERM_USER_REPORTED_OVER: "Du hast darüber berichtet",
      LONG_TERM_USER_DAYS: "Tage",
      LONG_TERM_USER_CHECK: "Prüfe deine Tage und den Status zum Power User",
      DAYS_STREAK_TRUE: "Du hattest eine Erfolgsserie! Mach es weiter, um ein Power User zu werden! Noch",
      DAYS_STREAK_FALSE: "Entschuldige, du hast verloren.",
      MORE_DAYS_TO_GO: "Tage bis zum Ende!",
      POWER_USER_REFRESH_FAIL: "Sie erfüllen die Kriterien für den Power User noch nicht.",
      POWER_USER_REFRESH_GRANTED: "Du bist ein Power User!"
    },
    TOOLTIP: {
      REFRESH: "Power-User-Status aktualisieren",
      TIME: "Gesamtzeit der berichteten Prozesse",
      TIME_TODAY: "Heute in KliX verbrachte Zeit vom Beginn des ersten Prozesses bis jetzt",
      RATIO: "Das Verhältnis der berichteten Zeit geteilt durch die Zeit",
      REPORTED: "Von Mitarbeitern gemeldete Überstunden. Dies ist die Zeit, die die Arbeitsnorm überschreitet",
      ACCEPTED: "Von Mitarbeitern gemeldete Überstunden, die von Teamleitern genehmigt wurden",
      BALANCE: "Über- oder Minusstunden-Saldo vom 01. Januar bis 31. Dezember des jeweiligen Jahres"
    },
    USER: "Benutzer",
    DISPLAY_PREFERENCES: {
      TITLE: "Anzeigeeinstellungen",
      MANAGEMENT_LEVEL: "Managementebene",
      TEAM_LEADER_LEVEL: "Team-Leader-Ebene",
      DEPUTY_TEAM_LEADER_LEVEL: "Deputy-Team-Leader-Ebene",
      EMPLOYEE_LEVEL: "Mitarbeiterebene",
      SHOW_DATA: "Daten anzeigen",
      EXCLUDED_FROM_PROFITABILITY_VIEW: "(Excluded from Profitability View)"
    },
    SPLIT_MODAL: {
      DESCRIPTION: "Die berichtete Zeit übersteigt die Gesamtzeit für den Antrag. Möchten Sie die gemeldete Zeit in einen Antrag und einen normalen Worklog aufteilen?",
      NO_DESCRIPTION: 'Wenn Sie "Nein" wählen, müssen Sie diesen Worklog vor dem Speichern bearbeiten.',
      YES: "Ja",
      NO: "Nein"
    },
    APPLICATION_OVERTIME: "Überstundenantrag"
  },
  STATS: {
    CLIENTS: "Mandanten",
    CLIENT_NAME: "Mandant",
    CLIENT_GROUP: "Gruppe",
    CLIENT_GROUPS: "Mandantengruppen",
    TYPE_CLIENT_NAME: "Suche des Mandanten...",
    TYPE_CLIENT_GROUP: "Suche des Mandantengruppen...",
    TYPE_EMPLOYEE_NAME: "Suche des Mitarbeitername...",
    TYPE_TEAM_NAME: "Suche des Teamname...",
    VA_TO_NVA: "VA/NVA",
    TIME: "Zeit",
    HOURLY_RATE: "Stündlich",
    CURRENCY: "Währung",
    AVAREGE_HOURLY_RATE: "~HR",
    PROFITABILITY_RATE: "Rentabilität",
    CHECKED: "Geprüft",
    DELETED: "Gelöscht",
    FULL_NAME: "Voller Name",
    REPORTED_TIME: "Berichtet",
    UNREPORTED_TIME: "Nicht berichtet",
    INTERRUPTERS: "Unterbrecher",
    REPORT: "Bericht",
    GENERATED_AT: "generiert am",
    GENERATED_BY: "von",
    FREQUENCY: "Häufigkeit",
    EXPORT_REPORT: "Exportreport",

    TURNOVER: "Gesamt-umsatz",
    INTERNAL_TIME: "Interne Zeit",

    SET_TARGETS: "Set Niemiecki",

    TEAM_DASHBOARD: "Dashboard",
    PROBLEMS: "Prozessprobleme",
    INACTIVITY_PERIODS: "Zeiten der Inaktivität",
    PROCESS_GROUPS: "Top Ten Mandanten",
    TOP_TEN_CLIENTS: "Top Ten Mandanten",
    TOP_TEN_PROCESSES: "Top Ten Prozesse",
    DAILY_REPORT: "Tagesbericht",
    PROFITABILITY_VIEW: "Rentabilitätsansicht",
    PROFITABILITY_REPORT: "Rentabilitätsbericht",
    DETAILED_VIEW: "Detailansicht",
    AVERAGE_HOURLY_RATE: "Durch-schnitt-licher Stunden-satz",
    EFFECTIVE_HOURLY_RATE: "Effektiver Stundensatz",
    PERCENT_OF_REPORTED_TIME: "% der berichteten Zeit",
    PERCENT_OF_VA_ACTIVITIES: "% der VA-Prozesse",
    PERCENTAGE_OF_TIME_REPORTED_MONTHLY: "Monatlich gemeldeten Zeit",
    PERCENTAGE_OF_OPPORTUNITY_TIME: "Gelegenheits Zeit",
    PERCENTAGE_OF_WORKLOG_ENTRIES_ACCEPTED: "Worklog-Einträge akzeptiert",
    PERCENTAGE_OF_WORKLOG_ENTRIES_CHANGED: "Worklog-Einträge manuell hin-zugefügt",
    ACCEPTED_OVERTIME_FOR_WHOLE_TEAM: "Überstunden akzeptiert",
    ACCEPTED_OVERTIME: "Über-stunden akzeptiert",
    REPORTED_OVERTIME: "Über-stunden gemeldet",
    CUMULATED_OVERTIME: "Über-stunden balance",
    REMAINING_OVERTIME: "Über-stunden balance",
    TOTAL_OVERTIME: "Gesamtüberstunden",
    OVERTIME: "Überstunden",
    EMPLOYEES: "Mitarbeiter",
    UNDERTIME: "Unterstunden",
    NO_OVERTIME: "Keine Überstunden",
    OTHER: "Sonstige",
    DATA_QUALITY: "Qualität",
    PROFITABILITY: "Rentabilität",
    AVERAGE: "Durchschnittsrate",
    EFFECTIVE: "Effektive Rate",
    AVERAGE_PROFITABILITY_RATE: "Durch-schnitt-liche Rent-abilitäts-rate",
    EFFECTIVE_PROFITABILITY_RATE: "Effektive Rentabilitätsrate",
    AVERAGE_PROFITABILITY_TREND_CHART: "Durchschnittliche Rentabilität",
    BACK_TO_TL_VIEW: "Zurück",
    TIME_SPENT: "Zeitaufwand",
    VA_PERCENT: "VA%",
    MAIN_EMPLOYEE: "Hauptangestellter",
    EMPLOYEE: "Mitarbeiter",
    NR_OF_PROCESS_PROBLEMS: "Anzahl der Prozessprobleme",
    H_TEAM: "team",
    H_TEAMS: "teams",
    H_NO_TEAM: "kein team",
    TEAMS: "Teams",
    TEAM_NAME: "Teamname",
    MAIN_TEAM: "Hauptteam",
    CHOOSE_TEAM: "Teams auswählen",
    SELECT_ALL: "Alle auswählen",
    CURRENTLY_IN_ANOTHER_TEAM: "Derzeit nicht in diesem Team",
    CURRENTLY_IN_LONG_TERM_VIEW: "Benutzer ist in Langzeiturlaub",
    CURRENTLY_BLOCKED: "User deleted",
    DURATION_OVER_DAYTIME: "Dauer überschneidet sich mit dem nächsten Tag",
    START_TIME_IS_NOT_BEFORE_ALL_WORKLOGS: "Startzeit ist nicht vor allen Worklogs",
    OVERTIME_REQUEST_ALREADY_ALLOCATED_ERROR: "Überstundenantrag ist bereits zugeordnet",
    ARCHIVED_AT: "arch:",
    NO_SITES: "keine Standorte",
    NO_PROFIT_CENTER: "keine Profit-Center",
    NO_PROFIT_CENTERS: "keine Profit-Centers",
    VA: "VA",
    NVA: "NVA",
    EUR: "EUR",
    SELECTED: "ausgewählt",
    NO_EMPLOYEES: "Keine Mitarbeiter in diesem Team",
    PROCESSES: "Prozesse",
    TOTAL_COST: "Gesamtkosten",
    TOTAL_MARGIN: "Gesamtmarge",
    CLIENT_TIME: "Mandantenzeit",
    TEAM_COST: "Teamkosten",
    PROFIT: "Profit",
    PERCENTAGE_WORKLOGS_CHANGED: "Worklog entries added manually",
    TOOLTIP: {
      TURNOVER: "Summe der Einnahmen für bestimmte Mandaten für ausgewählte Teams im ausgewählten Zeitbereic",
      INTERNAL_TIME: "Summe der Zeit (% der Gesamtzeit), die für interne Tätigkeiten und Unterbrechungen gemeldet wurde, die nicht mit Mandanten verbunden sind.",
      PERCENTAGE_OF_TIME_REPORTED_MONTHLY: "In KliX registrierte Gesamtzeit geteilt durch die Zeit, die gemäß den Arbeitsnormen der jeweiligen Mitarbeiter erwartet wurde. Der Indikator kann 100% nicht überschreiten",
      PERCENTAGE_OF_OPPORTUNITY_TIME: "Gemeldete Zeit für Internal-Prozesse, die kontinuierliche Verbesserung, Business Development und Schulungen darstellen, geteilt durch die gesamte gemeldete Zeit",
      PERCENTAGE_OF_WORKLOG_ENTRIES_ACCEPTED: "Anzahl der Worklog-Einträge, die von dem/den Teamleiter(n) in der Teamleiteransicht akzeptiert wurden, geteilt durch die Gesamtzahl der gemeldeten Worklogs",
      PERCENTAGE_OF_WORKLOG_ENTRIES_CHANGED: "Anzahl der Worklogs, die manuell von Teamleitern oder Power-Usern hinzugefügt wurden, geteilt durch die Gesamtzahl der Worklogs",
      AVERAGE: "Gesamteinnahmen geteilt durch die gesamte gemeldete Zeit. Dies beinhaltet interne Arbeit, Unterbrecher, Urlaub und andere Abwesenheiten",
      EFFECTIVE: "Gesamteinnahmen geteilt durch die für Mandantenarbeit gemeldete Zeit. Dies beinhaltet alle Prozesse und Unterbrecher, die im Zusammenhang mit Mandanten gemeldet wurden",
      PROFITABILITY_RATE: "Stundensatz geteilt durch Kostensatz. Der Kostensatz der Arbeit wird unter Berücksichtigung der gemeldeten Zeit und des Kostensatzes für jede Mitarbeiterebene, die die Arbeit ausführt, berechnet. Mitarbeiterebenen sind Junior, Regular, Senior, mittlerer Manager und Top Manager",
      REPORTED_OVERTIME: "Von Mitarbeitern gemeldete Überstunden. Dies ist die Zeit, die ihre Arbeitsnorm überschreitet",
      ACCEPTED_OVERTIME_FOR_WHOLE_TEAM: "Von Mitarbeitern gemeldete Überstunden, die von Teamleitern genehmigt wurden",
      CUMULATED_OVERTIME: "Über- oder Minusstunden-Saldo vom 01. Januar bis 31. Dezember des jeweiligen Jahres",
      EMPLOYEE: "Mitarbeitername",
      TEAM_NAME: "Offizieller Name des Teams im System",
      AVERAGE_HOURLY_RATE: "Gesamteinnahmen geteilt durch die für das jeweilige Team gemeldete Gesamtzeit. Dies beinhaltet interne Arbeit, Unterbrecher, Urlaub und andere Abwesenheiten",
      AVERAGE_PROFITABILITY_RATE: "Stundensatz geteilt durch den Kostensatz für das jeweilige Team. Der Kostensatz der Arbeit wird unter Berücksichtigung der gemeldeten Zeit und des Kostensatzes für jede Mitarbeiterebene, die die Arbeit ausführt, berechnet. Mitarbeiterebenen sind Junior, Regular, Senior, mittlerer Manager und Top Manager",
      CLIENT_GROUP: "Offizieller Name der Mandantengruppe im System",
      EFFECTIVE_HOURLY_RATE: "Gesamteinnahmen geteilt durch die gesamte gemeldete Zeit für die jeweilige Mandantengruppe. Dies beinhaltet alle Prozesse und Unterbrecher, die im Zusammenhang mit Mandanten gemeldet wurden",
      EFFECTIVE_PROFITABILITY_RATE: "Stundensatz geteilt durch Kostensatz für die jeweilige Mandantengruppe. Der Kostensatz der Arbeit wird unter Berücksichtigung der gemeldeten Zeit und des Kostensatzes für jede Mitarbeiterebene, die die Arbeit ausführt, berechnet. Mitarbeiterebenen sind Junior, Regular, Senior, mittlerer Manager und Top Manager",
      TIME_SPENT: "Gesamtzeit, die für die jeweilige Mandantengruppe berichtet wurde",
      VA_PERCENT: "Gemeldete Zeit für (VA) Value Added-Prozesse geteilt durch die gesamte gemeldete Zeit für die jeweilige Mandantengruppe",
      MAIN_EMPLOYEE: "Mitarbeiter, das die meiste Zeit für eine bestimmte Mandantengruppe berichtet hat",
      MAIN_TEAM: "Team, das die meiste Zeit für eine bestimmte Mandantengruppe berichtet hat",
      NR_OF_PROCESS_PROBLEMS: "Gesamtzahl der gemeldeten Prozessprobleme",
      CLIENT_NAME: "Offizieller Mandantenname im System",
      CLIENT_GROUP_BELONGS: "Offizieller Name der Mandantengruppe, zu welcher der Mandant gehört",
      CLIENT_EFFECTIVE_HOURLY_RATE: "Gesamteinnahmen geteilt durch die gesamte gemeldete Zeit für den jeweiligen Mandanten. Dies beinhaltet alle Prozesse und Unterbrecher, die im Zusammenhang mit Mandanten gemeldet wurden",
      CLIENT_EFFECTIVE_PROFITABILITY_RATE: "Stundensatz geteilt durch den Kostensatz für den jeweiligen Mandanten. Der Kostensatz der Arbeit wird unter Berücksichtigung der gemeldeten Zeit und des Kostensatzes für jede Mitarbeiterebene, die die Arbeit ausführt, berechnet. Die Mitarbeiterebenen sind Junior, Regular, Senior, mittlerer Manager und Top Manager",
      CLIENT_TIME_SPENT: "Gesamtzeit, die für den jeweiligen Mandanten gemeldet wird",
      CLIENT_VA_PERCENT: "Gemeldete Zeit für (VA) Value Added-Prozesse geteilt durch die gesamte gemeldete Zeit für die jeweilige Mandanten",
      CLIENT_MAIN_EMPLOYEE: "Mitarbeiter, das die meiste Zeit für einen bestimmten Mandanten berichtet hat",
      CLIENT_MAIN_TEAM: "Team, das die meiste Zeit für einen bestimmten Mandanten berichtet hat",
      PERCENTAGE_WORKLOGS_CHANGED_TOOLTIP: "Anzahl der Worklogs, die manuell von Teamleitern oder Power-Usern hinzugefügt wurden, geteilt durch die Gesamtzahl der Worklogs",
      WORKLOGS: {
        NAME: "Offizieller Mandantenname im System",
        PROCESS_GROUP: "Offizieller Name der Prozessgruppe im System",
        PROCESS: "Offizieller Prozessname im System",
        DATE: "Datum des berichteten Prozesses",
        START_TIME: "Uhrzeit, ab der einen Prozess gemeldet wird",
        END_TIME: "Uhrzeit, zu der ein Prozess nicht mehr gemeldet wird",
        DURATION: "Zeitaufwand für einen Prozess",
        DURATION_WITH_INVOICED_TIME: "Dauer - Zeitaufwand für einen Prozess. Fakturierte Zeit - Zeitaufwand, der für einen Vorgang in Rechnung gestellt wurde",
        VALUE_ADDED: "Zeigt an, ob ein Prozess VA (vom Mandanten bezahlt) oder NVA (nicht vom Mandanten bezahlt) ist",
        VOL: "Anzahl der für den Prozess gemeldeten Einheiten (z. B. Buchungszeilen, Dokumente)",
        ADDED_MAN: "Ein manuell vom Teamleiter oder Power-User hinzugefügter Eintrag",
        COMMENT: "Interne Kommentare gemeldet für einen Prozess",
        INVOICE_DETAILS: "Arbeitsumfang, der in der Rechnung angezeigt werden soll",
      },
      OVERTIME: {
        COMMENT: "Zusätzlicher Kommentar",
        BALANCE_PREVIOUS: "Über-/Minusstunden Balance aus den Vorjahren",
        OVERTIME_BALANCE: "Über- oder Minusstunden-Saldo vom 01. Januar bis 31. Dezember des jeweiligen Jahres einschließlich der abgerechneten Überstunden aus Überstundenanträgen",
        DATE: "Datum des berichteten Tages",
        WORKNORM: "Erforderliche Zeitspanne, in der ein Mitarbeiter verpflichtet ist, sich zu melden",
        WORK_TYPE: "Zeit der individuellen Arbeitsvereinbarungen (Stundenbasiert/Langzeiturlaub/Regelarbeitszeit)",
        WORK_TIME: "Berichtete Zeit an einem ausgewählten Datum",
        REPORTED_OVERTIME: "Von einem Mitarbeiter gemeldete Überstunden. Dies ist die Zeit, die die Arbeitsnorm überschreitet",
        ACCEPTED_OVERTIME: "Von einem Teamleiter akzeptierte Überstunden",
        MODE: "Typ des Überstundenmodus (manuell/automatisch/deaktiviert)",
        OVERTIME_REQUEST_BALANCE: "Überstundensaldo aus Überstundenanträgen vom 01. Januar bis 31. Dezember des jeweiligen Jahres"
      },
      PROFITABILITY: {
        APPLICATION_OVERTIME: "Overtime hours reported by employee on overtime request",
        ALLOCATED_APPLICATION_OVERTIME: "Overtime hours allocated from overtime requests from 01 January till 31 December of given year"
      },
      APPLICATION_OVERTIME: "Überstunden, die von einem Mitarbeiter auf einem Überstundenantrag für ein ausgewähltes Datum gemeldet wurden",
      ALLOCATED_APPLICATION_OVERTIME: "Abgerechnete Überstunden am gewählten Tag aus dem gewählten Überstundenantrag",
      TOTAL_COST: "Summe der multiplizierten Zeiten und der Stundensätze auf Mitarbeiterebene",
      TOTAL_MARGIN: "Gesamtumsatz abzüglich der Gesamtkosten",
      TIME_FOR_CLIENTS: "Für Kunden aufgewendete Zeit",
      EFFECTIVE_HOURLY_RATE_FOR_TEAM: "Total income divided by total time reported for the given team. This includes all processes and interrupters that were reported in connection to clients",
      EFFECTIVE_PROFITABILITY_RATE_FOR_TEAM: "Hourly rate divided by cost rate for the given team. Cost rate of work is calculated considering time reported and the cost rate associated with each employee level performing the work. Employee levels are junior, regular, senior, middle manager and top manager",
    }
  },
  OVERTIME: {
    DATE: "Datum",
    WORKNORM: "Arbeitsnorm",
    WORK_TIME: "Arbeitszeit",
    TYPE: "Berichtstyp",
    TOTAL: "Total",
    OVERTIME: "Im Laufe der Zeit",
    REPORTED: "Berichtet",
    ACCEPT: "Akzeptiert",
    CUMULATED: "Verbleibend",
    TOTAL_CUMULATED: "Gesamt Verbleibend",
    OVERTIME_BALANCE: "Überstunden balance",
    UNDERTIME_BALANCE: "Unterstunden balance",
    STATS: "Worklogs",
    AUTO: "Automatisch",
    DISABLED: "Deaktiviert",
    MODE: "Modus",
    COMMENT: "Kommentar",
    MANUAL: "Manuell",
    SUM: "Summe",
    ERROR: "Speichern nicht möglich. Überprüfen Sie, ob die akzeptierten Überstunden die angegebene Überstunden nicht überschreiten.",
    ERROR_GET: "Es gibt ein Problem beim Laden von Überstunden. Bitte überprüfen Sie Ihre Internetverbindung.",
    WAITING: "Warten",
    ANNUAL_SET_OFFS: "Jährliche Aufrechnungen",
    OVERTIME_BALANCE_PREVIOUS: "Über-/Minusstunden Balance aus den Vorjahren",
    PLACEHOLDER: {COMMENT: "Geben Sie einen Kommentar ein..."},
    APPLICATION_OVERTIME: "Überstundenantrag",
    ALLOCATED_APPLICATION_OVERTIME: "Zugeordnete Überstundenanträge",
    TOOLTIP : {DISABLED_SETTLEMENT: "Dieser Benutzer hat keine Überstunden zu verwenden",
    OVERTIME_BALANCE_PREVIOUS: "Über-/Minusstunden Balance aus den Vorjahren",
  },

    CUMULATED_FROM_PREVIOUS_YEARS: "Kumuliert aus den Vorjahren",
    USE_FIFO: "Verwenden (FIFO)",
    RESET_FIFO: "Zurücksetzen (FIFO)",

    SETTLE: "Begleichen",
    EV_SETTLE: "Aussicht begleichen",
    MODAL: {
      DATE: "Datum",
      VIEW: "Aussicht",
      OVER_TIME_BALANCE: "Über-/Minusstunden Balance",
      ACCEPTED_TIME_BALANCE: "genehmigte Über-/Minusstunden Balance",
      WORKLOGS_ACCEPTED: "% der akzeptierten Worklogs",
      USED_OVERTIMES: "Genutzte Überstunden",
      COMMENT: "Kommentar",
      ACTIONS: "Aktionen",
      WORKNORM: "Arbeitsnorm",
      WORKTIME: "Arbeitszeit",
      ACCEPTED_OVERTIME: "Genehmigte Überstunden",
      ALREADY_USED: "Bereits verwendet",
      OVERTIME_TO_USE: "Verfügbare Überstunden",
      CUMULATED_OVERTIME: "Über-/Minusstunden Balance",
      SETTLED_OVERTIME: "Abgerechnete Überstunden",
      DECLINE: "Löschen",
      APPLICATION_OVERTIME: "Überstundenantrag",
      OVER_UNDER_TIME: "Über-/Minusstunden",
      ALREADY_ALLOCATED: "Bereits zugeordnet",
      TOOLTIP: {
        DATE: "Jahr der gemeldeten Überstunden",
        SETTLED_DATE: "Datum der gemeldeten Abrechnung",
        OVER_TIME_BALANCE: "Über- oder Minusstunden-Saldo vom 01. Januar bis 31. Dezember des jeweiligen Jahres",
        ACCEPTED_TIME_BALANCE: "Über- oder Minusstunden-Saldo vom 01. Januar bis 31. Dezember des jeweiligen Jahres von einem Teamleiter akzeptierte",
        WORKLOGS_ACCEPTED: "Anzahl der Worklog-Einträge, die von dem/den Teamleiter(n) in der Teamleiteransicht akzeptiert wurden, geteilt durch die Gesamtzahl der gemeldeten Worklogs",
        USED_OVERTIMES: "Anzahl der genutzten Überstunden in diesem Jahr",
        COMMENT: "Zusätzlicher Kommentar",
        SETTLED_OVERTIME: "Anzahl der abgerechneten Überstunden",
        WORKNORM: "Erforderliche Zeitspanne, in der ein Mitarbeiter verpflichtet ist, sich zu melden",
        WORKTIME: "Berichtete Zeit an einem ausgewählten Datum",
        ACCEPTED_OVERTIME: "Genehmigte Überstunden",
        ALREADY_USED: "Anzahl der Überstunden, die bereits als Abrechnungen verwendet wurden",
        OVERTIME_TO_USE: "Hier ist die Anzahl der Überstunden einzugeben, die von Tagen, an denen Überstunden gemeldet und akzeptiert wurden, verbraucht werden können",
        APPLICATIONS_OVERTIME_BALANCE: "Überstundensaldo aus Überstundenanträgen vom 01. Januar bis 31. Dezember des jeweiligen Jahres",
        APPLICATION_OVERTIME: "Überstunden, die von Mitarbeitern auf Überstundenanträgen vom 01. Januar bis 31. Dezember des jeweiligen Jahres gemeldet wurden",
      },
      DISABLED_FOR_NOT_WORKNORM: "Your work type is not Worknorm. You have to manually enter 'OVERTIME TO USE'.",
      DISABLED_WHEN_COVERED: "'ALREADY ALLOCATED' fully covers 'OVER(UNDER-) TIME'. You have to manually enter 'OVERTIME TO USE'."
    },
    MODAL_SETTLE:{
      CREATE: "Abrechnung erstellen",
    },
    ALLOCATED_OVERTIME_REQUEST: "Antrag auf zugewiesene Überstunden:",
    APPLICATIONS_OVERTIME_BALANCE: "Saldo des Überstundenantrags:",
    REQUESTS_OVERTIME_BALANCE: "Saldo der Abrechnungen der vorherigen Jahre:",
    SETTLED_OVERTIME_REQUEST: "Abrechnungsantrag:",
  },
  AUTH: {
    LOGIN_TITLE: "Anmelden",
    LOGIN_INFO: "Bitte geben Sie Ihre Anmeldedaten ein, um Zugang zum Zeiterfassungssystem zu erhalten.",
    EMAIL: "E-Mail",
    EMAIL_PLACEHOLDER: "bob@roedl.pro",
    PASSWORD_PLACEHOLDER: "Passwort hier eingeben…",
    PASSWORD: "Passwort  ",
    CODE: "Code",
    CODE_PLACEHOLDER: "Code",
    EMAIL_CODE: "5 Anmeldeversuch fehlgeschlagen. Wenn Ihre E-Mail-Adresse in KliX registriert wurde, überprüfen Sie Ihre Mailbox. Sie erhalten einen Code, mit dem Sie ein neues Passwort eingeben können.",
    RESEND_CODE: "Senden Sie die E-Mail erneut mit dem Code",
    OVERDUE_PASS1: "Ihr Passwort wurde über ein Jahr lang verwendet.",
    OVERDUE_PASS2: "Es ist Zeit, es zu ändern!",
    ENTER_NEW_PASS: "Geben Sie hier ein neues Passwort ein ...",
    ENTER_CONFIRM: "Passwort hier bestätigen ...",
    TRY_AGAIN: "Versuch es noch einmal",
    FAILED: "Etwas ist schief gelaufen!",
    DONE: "Ihr Passwort wurde erfolgreich geändert!",
    DONT_USE1: "Bitte verwenden Sie nicht Ihren Vor-, Nachnamen und Firmennamen.",
    DONT_USE2: "Sie haben in Ihrem neuen Passwort Wörter von unten verwendet:",
    LOGIN: "Anmelden",
    LOGIN_SSO: "Anmelden mit Rödl & Partner SSO",
    SIGNED_IN_AS: "Angemeldet als",
    FORGOT_PASSWORD: "Passwort vergessen?",
    ERROR: "Fehler bei der Anmeldung. Überprüfen Sie Ihre Anmeldedaten.",
    ACCOUNT: "Benutzerkonto",
    LOGOUT: "Abmelden",
    CHANGE_PASSWORD: "Passwort ändern",
    RESET_PASSWORD: "Passwort zurücksetzen",
    RESET_PASSWORD_INFO: "Geben Sie bitte Ihre E-Mail-Adresse an, um das Passwort zurückzusetzen. Sie erhalten  eine E-Mail mit Anweisungen zum weiteren Vorgehen.",
    SEND_RESET_PASSWORD_INSTRUCTIONS: "Senden",
    SETTING_NEW_PASSWORD: "Neues Passwort einrichten…",
    SENDING_LINK_SUCCESS: "Wenn Sie die richtige E-Mail-Adresse angegeben haben, sollten Sie bald eine E-Mail mit Anweisungen zum weiteren Vorgehen erhalten.",
    SET_NEW_PASSWORD: "Neues Passwort einrichten",
    SET_NEW_PASSWORD_INFO: "Bitte geben Sie Ihr neues Passwort ein. Es muss aus mindestens 8 Zeichen, einem Sonderzeichen, einem Groß- und Kleinbuchstaben und einer Ziffer bestehen. Verwenden Sie nicht Ihren Namen und Firmennamen.",
    NEW_PASSWORD: "Neues Passwort",
    NEW_PASSWORD_CONFIRMATION: "Neues Passwort bestätigen",
    PASSWORDS_DO_NOT_MATCH: "Passwort und Bestätigung stimmen nicht überein.",
    SENDING_ERROR: "Wir konnten Ihnen keine Anweisung zum Zurücksetzen des Passworts zusenden. Bitte versuchen Sie es später noch einmal oder kontaktieren Sie den Administrator.",
    ERROR_SETTING_PASSWORD: "Fehler bei der Passworteinrichtung. Vergewissern Sie sich, dass das Passwort die Kriterien erfüllt.",
    PASSWORD_TOO_SHORT: "Das eingegebene Passwort ist zu kurz.",
    MIGRATION_TO_KLIX_DOMAIN: "Das System wird auf eine neue Domain klix-web.com verschoben. Bitte klicken Sie auf die Schaltfläche rechts, um sich erneut bei einer neuen Domain anzumelden.",
    MIGRATION_TO_KLIX_DOMAIN_RELOGIN: "Anzumelden",
    BPE_VIDEO: "BPE Program erklärt"
  },
  WORK: {
    CLIENTS: "Mandanten",
    PROCESS_GROUPS: "Prozessgruppen",
    PROCESS: "Prozesse",
    TYPE_CLIENT_NAME: "Suche des Mandanten...",
    SELECTED_CLIENT: "Mandant:",
    PROCESS_GROUP: "Prozessgruppe:",
    SELECT_ANOTHER_CLIENT: "Anderen Mandanten auswählen",
    SELECT_ANOTHER_INTERRUPT: "Andere Unterbrechung auswählen",
    SELECT_ANOTHER_SERVICE_LINE: "Andere Geschäftsfeld auswählen",
    PROCESSES: "Prozessgruppe wählen, mit deren Bearbeitung begonnen wird",
    BACK: "Zurück zum Mandanten und der Wahl der Prozessgruppe",

    REPORT_FINISH: "Prozessabschluss berichten",

    REPORT_PROJECT: "Projekt auswählen",

    INTERRUPTS: "Unterbrechung berichten",
    CHOOSE_CLIENT: "Mandanten auswählen",
    CHOOSE_SERVICE_LINE: "Geschäftsfeld auswählen",
    COMMENT: "Zusätzlicher Kommentar",
    INVOICE_DETAILS: "Rechnungs-Details",
    REPORT_INTERRUPTER: "Unterbrechung beenden",
    VA: "VA",

    FINISH_PROCESS: "Prozess abschließen",
    REPORT_VOLUME: "Menge berichten",

    FINISH_PROCESS_REPORTING_PROBLEM: "Beenden und Problem berichten",
    PROBLEM_TYPE: "Problemart auswählen",
    CHOOSE_THIS_CLIENT: "Wählen",
    ERROR: "Fehler beim Speichern der Daten",
    ERROR_PROCESS_TOO_LONG: "- Prozess begann an einem anderen Tag!",
    ERROR_SENDING: "Beachten Sie bitte, dass wir Ihre Dateneingabe nicht bearbeiten konnten. Stellen Sie sicher, dass Sie nicht mit mehreren Browser-Registerkarten arbeiten. Ist dies nicht der Fall, versuchen Sie es später noch einmal oder kontaktieren Sie den Administrator.",
    ERROR_VACATION: "Sie können den Prozess während Ihres Urlaubs nicht melden.",
    ERROR_KLIX_CONNECTION: "Aufgrund von Problemen mit KliX Server ist die Berichterstattung fehlgeschlagen.",
    YOU_ARE_ON_VACATION: "Du bist im Urlaub.",
    REMOVE_VACATION: "Entfernen Sie Urlaub, um Ihre Zeit zu melden.",

    VOLUME: "Volumen",

    NOTE_FINISH: "Sie haben den Abschluss des Prozesses berichtet",
    NOTE_INTERRUPTION: "Sie haben eine Unterbrechung berichtet",
    NOTE_REPORTED: "Sie haben ein Problem während des Abschließens berichtet",
    NOTE_STARTED: "Sie haben mit Bearbeitung begonnen. ",
    NOTE_RESUMED: "Fortsetzen",
    CANCEL_CONFIRMATION: "Möchten Sie den Prozess wirklich BEENDEN?",
    RESUME_QUESTION: "Möchten Sie den zuvor begonnenen Prozess BEENDEN?",
    RESUME_PROCESS: "Prozess fortsetzen",
    RESUME_INTERRUPTION: "Unterbrechung fortsetzen",
    EXIT: "Prozess beenden",
    PROCESS_TOO_LONG: "Der Prozess wurde zu einem anderen Datum gestartet - er wird abgebrochen. Beenden Sie Ihren Prozess immer am Ende des Tages.",

    OVERTIME_BALANCE: "Überstundenbilanz",
    TODAY_OVERTIME: "Heute Überstunden",
    TIME_TODAY: "Heutige Zeit",
    BAR_TEXT: "Heute berichtete Zeit",
    ERRORS: {
      PREFERENCES: "Wir konnten Ihre Vorlieben nicht bekommen. Versuchen Sie, die Seite neu zu laden, oder wenden Sie sich an den Administrator.",
      DAILY_STATS: "Wir konnten Ihre täglichen Statistiken nicht erhalten. Versuchen Sie, die Seite neu zu laden, oder wenden Sie sich an den Administrator."
    },

    HIDDEN_PROCESSES: "Ausgeblendete Prozesse",
    HIDE_MESSAGE: "Möchten Sie diesen Prozess für alle Mandanten oder nur für {{name}} ausblenden?",
    UNHIDE_MESSAGE: "Möchten Sie diesen Prozess wieder einblenden?",
    UNHIDE: "Einblenden",
    FOR_ALL_CLIENTS: "Für alle Mandanten",
    ONLY_FOR_ONE_CLIENT: "Nur für",
    NO_PROBLEMS_ARE_DEFINED: "No problems are defined on this process group",
    OVERTIME_APPLICATION: "Überstundenantrag",
    WITH_OVERTIME_APPLICATION: "Wenn Sie einen Worklog mit einem Überstundenantrag senden möchten, wählen Sie einige aus der Liste aus",
    WITHOUT_OVERTIME_APPLICATION: "Falls nicht, lassen Sie das Feld leer.",
    CHANGE_FINISH_TIME: "Endzeit ändern",
    MAXIMUM_PROCESS_OFFSET: "Der maximale Prozessversatz ist nur bis zum Ende der letzten Unterbrechung oder Minute vor dem Öffnen dieses Fensters möglich. Man kann die Endzeit von {{min}} bis {{max}} einstellen",
    CHANGED_FINISH_TIME_DISABLED_TOOLTIP: "Diese Option ist jetzt nicht verfügbar. Der Abschlussprozess kann um {{min}} Uhr beginnen",
    FINISH_TIME_POSSIBILITIES: "Man kann die Endzeit von {{min}} bis {{max}} einstellen",
    LOADING_POSSIBLE_FINISH_TIME: "Informationen über die mögliche Endzeit werden geladen",
    BILLING_TYPE: "Abrechnungsart",
    BILLING_TYPE_TOOLTIP: "Eine andere Abrechnungsart als die Standardart für einen bestimmten Mandanten auswählen",
    CHOOSE_CLIENT_AND_PG: "Mandant und Prozessgruppe auswählen",
    CHOOSE_CLIENT_FOR_NEW_PROCESS: "Mandant auswählen",
    CHOOSE_PG_FOR_NEW_PROCESS: "Prozessgruppe auswählen",
    CHANGE_INVOICING_TIME: "Änderung der Rechnungsstellungszeit",
    REPORTED_TIME: "Gemeldete Zeit",
    TIME_TO_INVOICE: "Zeit für die Rechnungsstellung",
    START_TIME: "Startzeit",
    SET_START_TIME: "Startzeit festlegen",
    START_TIME_CANNOT_BE_IN_FUTURE: "Die Startzeit kann nicht in der Zukunft liegen",
  },
  CHECK_VERSION: {
    NEW: "Sie nutzen die {{actualVersion}} Version des Anwendungsprogramms. Es ist eine {{newVersion}} Version verfügbar. Schließen Sie den Arbeitsvorgang ab und laden Sie die Seite erneut."
  },
  COUNTRIES: {
    TITLE: "Länder",
    NEW: "Neues Land hinzufügen",
    SEARCH: "Ländernamen eingeben",
    NAME: "Ländername",
    COUNTRY: "Ländername",
    CURRENCY: "Währungscode",
    CURRENCY_TOOLTIP: "ISO 4217 Standard, z.B. USD, EUR.",
    EDIT: "Bearbeiten",
    VIEW: "Ansehen",
    NEW_COUNTRY: "Neues Land",
    EDIT_COUNTRY: "Land bearbeiten",
    CODE: "Code",
    CODE_TOOLTIP: "ISO 3166-1 Alpha-2 code standard, e.g. US, GB.",
    LEVELS: "Levels",
    L01: "L01 - non-Fee-Earner",
    L02: "L02 - Associate",
    L03: "L03",
    L04: "L04 - Senior Associate",
    L05: "L05",
    L06: "L06 - Manager",
    L07: "L07",
    L08: "L08 - Associate Partner",
    L09: "L09",
    L10: "L10 - Partner / Equity Partner / Shareholder"
  },
  FLAGS: {
    TITLE: "Feature-Flags",
    SEARCH: "Ländernamen eingeben",
    EDIT: "Bearbeiten",
    NAME: "Land",
    EDIT_FLAGS: "Flaggen bearbeiten"
  },
  INTERRUPTS: {
    TITLE: "Unterbrecher",
    SEARCH: "Unterbrecherbezeichnung eingeben",
    NAME: "Unterbrecherbezeichnung",
    ADD: "Neuen Unterbrecher hinzufügen",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    NEW_INTERRUPT: "Neuer Unterbrecher",
    EDIT_INTERRUPT: "Unterbrecher bearbeiten",
    DELETE_INTERRUPT: "Unterbrecher löschen"
  },
  GROUPS: {
    TITLE: "Prozessgruppen",
    SEARCH:"Gruppenbezeichnung eingeben",
    NEW: "Neue Prozessgruppe hinzufügen",
    NAME: "Bezeichnung",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    NEW_GROUP: "Neue Prozessgruppe",
    GROUP_NAME: "Gruppenbezeichnung",
    EDIT_GROUP: "Gruppe bearbeiten",
    DELETE_GROUP: "Gruppe löschen",
    VALIDATION_ERROR: "Ungültige(s) Zeichen im Namen"
  },
  COUNTRY: {
    TITLE: "Prozessgruppen-Konfigurierung",
    SEARCH: "Bezeichnung eingeben",
    NEW: "Neue Prozessgruppen-Konfigurierung hinzufügen",
    NAME: "Lokale Bezeichnung",
    DESCRIPTION: "Beschreibung",
    COUNTRY: "Land",
    CANNONICAL_NAME: "Global name",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    NEW_CONFIGURATION: "Neue Prozessgruppen-Konfigurierung",
    CONFIGURATION_NAME: "Konfigurierungsbezeichnung",
    PROCESS_GROUP_ID: "Prozessgruppenbezeichnung",
    EDIT_CONFIGURATION: "Prozessgruppenbezeichnung bearbeiten",
    DELETE_CONFIGURATION: "Prozessgruppen-Konfigurierung löschen",
    PROCESSES: "Ansehen",
    EDIT_COUNTRY: "Länderwerte bearbeiten",
    COUNTRY_NAME: "Ländername",
    CURRENCY_CODE: "Währungscode",
    CURRENCY_CODE_TOOLTIP: "ISO 4217 Standard, z.B. USD, EUR.",
    PROJECTS_FLAG: "Projektkennzeichen",
    PROJECTS_SET_MANUALLY: "Manuell eingestellte Projekte",
    PROJECTS_FROM_ERP_SYSTEM: "Projekte aus dem ERP-System",
    PROJECTS_NONE: "Keine",
    EDIT_FEATURE: "Feature-Flags bearbeiten",
    PARTTIMEVACATION: "Part-time vacation",
    CODE: "Code",
    CODE_TOOLTIP: "ISO 3166-1 Alpha-2 code standard, e.g. US, GB.",
    L01: "L01 - non-Fee-Earner",
    L02: "L02 - Associate",
    L03: "L03",
    L04: "L04 - Senior Associate",
    L05: "L05",
    L06: "L06 - Manager",
    L07: "L07",
    L08: "L08 - Associate Partner",
    L09: "L09",
    L10: "L10 - Partner / Equity Partner / Shareholder",
    EDIT_SENIORITY_LEVELS: "Levels bearbeiten",
    PROFIT_CENTER_ASSIGNED_ERROR: "Sie können ein Profit Center nicht löschen, da es mindestens einem Team zugeordnet ist.",
    VALUES: {
      TITLE: "Werte",
      COUNTRY_LABEL: "Bezeichnung",
      COUNTRY_VALUE: "Wert",
      EDIT: "Werte bearbeiten"
    },
    HOLIDAYS: {
      TITLE: "Feiertagskalender",
      ADD_NEW: "Neuen Tag hinzufügen",
      DATE: "Tag",
      SITE_NAME: "Standortbezeichnung",
      YEAR: "Jahr",
      ACTIONS: "Aktionen",
      DELETE: "Löschen",
      NEW_HOLIDAY: "Neu Ferien",
      DATE_PLACEHOLDER: "2012-12-25",
      DATE_TOOLTIP: "Format: JJJJ-MM-TT"
    },
    FEATUREFLAG: {
      TITLE: "Feature-Flags",
      EDIT: "Feature-Flags bearbeiten",
      FEATURE: "Funktionalität",
      VISIBLE: "Sichtbar"
    },
    INTERRUPTS: {
      TITLE: "Unterbrecher-Konfigurierungen",
      SEARCH: "Bezeichnung eingeben",
      NAME: "Bezeichnung",
      DESCRIPTION: "Beschreibung",
      COUNTRY: "Land",
      HAS_SERVICE_LINE: "Hat eine Serviceline?",
      INCLUDE_IN_REPORTS: "In Berichte aufnehmen?",
      HAS_CLIENT: "Hat einen Mandanten?",
      NEW: "Neue Unterbrecher-Konfigurierung hinzufügen",
      EDIT: "Bearbeiten",
      DELETE: "Löschen",
      NEW_INTERRUPT: "Neue Unterbrecher-Konfigurierung",
      EDIT_INTERRUPT: "Unterbrecher-Konfigurierung bearbeiten",
      DELETE_INTERRUPT: "Unterbrecher-Konfigurierung löschen",
      INTERRUPT_ID: "Unterbrecherbezeichnung",
      ADD_CONFIRMATION: "Möchten Sie diese Unterbrecher-Konfigurierung wirklich hinzufügen? Die Werte 'Hat Serviceline?', 'In Berichte aufnehmen?' und 'Hat Mandanten?' können nicht bearbeitet werden.",
      HAS_VALUE_ADDED: "Hat VA-Option?"
    }
  },
  PROCESSES: {
    TITLE: "Prozesse",
    SEARCH: "Prozessbezeichnung eingeben",
    NEW: "Neuen Prozess hinzufügen",
    NAME: "Local translation",
    ID_NAME: "Global name",
    DESCRIPTION: "Local Beschreibung",
    COMMENT_REQUIRED_BY_DEFAULT: "Kommentar erforderlich als Standardeinstellung",
    HAS_VOLUME_BY_DEFAULT: "Hat Menge als Standardeinstellung",
    VALUE_ADDED_BY_DEFAULT: "Mehrwert als Standardeinstellung",
    INCLUDE_IN_REPORTS: "In Berichte aufnehmen",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    NEW_PROCESS: "Neuer Prozess",
    PROCESS_NAME: "Prozessbezeichnung",
    PROCESS_DESCRIPTION: "Prozessbeschreibung",
    PRODUCTIVITY_POINTS: "Productivity-Punkte",
    IS_HIDDEN: "Versteckt",
    IS_OPPORTUNITY_TIME: "Gelegenheits Zeit",
    IS_VACATION: "Ist Urlaub",
    EDIT_PROCESS: "Prozess bearbeiten",
    DELETE_PROCESS: "Prozess löschen",
    VOLUME_DEFINITION: "Definition der Menge",
    OUTPUT_TYPE_LIST: "Liste der Leistungen",
    OUTPUT_TYPE: "Leistung",
    OUTPUT_TYPE_DESCRIPTION: "Leistungstyp für einen Prozess",
    OUTPUTS: "Leistung",
    ALLOW_CHANGING_VALUE_ADDED: "Allow changing VA/NVA"
  },
  USERS: {
    TITLE: "Benutzer",
    SEARCH: "Vollständigen Namen eingeben",
    FULL_NAME: "Vollständiger Name",
    EMAIL_ADDRESS: "E-Mail-Adresse",
    ROLE: "Funktion",
    IS_ADMIN: "Ist Master-Admin?",
    IS_LOCAL_ADMIN: "Ist lokaler Admin?",
    IS_INTEGRATION_ADMIN: "Ist Integrations-Admin?",
    CAN_EDIT_ACCEPTED: "Aktualisierungen akzeptiert",
    BLOCKED_AT_F: "Gesperrt bei",
    EDIT: "Bearbeiten",
    USER_EDITION: "Benutzer bearbeiten",
    RESTRICTED_CLIENT_ACCESS: "Eingeschränkter Clientzugriff",
    CAN_EXPORT_WORKLOG: "Kann Worklog exportieren?",
    CAN_IMPORT_INCOME: "Kann Umsätze importieren?",
    CAN_IMPORT_INCOME_COUNTRYWIDE: "Kann Einkommen landesweit importieren?",
    CAN_UPDATE_RATES: "Kostensätze bearbeiten",
    CAN_VIEW_RATES: "Kostensätze anzeigen",
    CAN_ACCESS360_VIEW: "360 Ansicht",
    CAN_ACCESS_FLEXITIME: "Flexitime Ansicht",
    MANAGEMENT_VIEW_HIDDEN: "Managementansicht ausgeblendet",
    NEW: "Neuen Benutzer hinzufügen",
    VIEW: "Ansehen",
    PASSWORD: "Passwort",
    SITE_ID: "Standortbezeichnung",
    SENIORITY_LEVEL: "Mitarbeiterebene",
    TYPE: "Berichtstyp",
    STANDARD_WORKING_HOURS: "Standardarbeitsstunden",
    VALID_FROM: "Gültig ab",
    EDIT_USER: "Benutzer bearbeiten",
    TEAM_ID: "Team",
    NEW_USER: "Neuen Benutzer hinzufügen",
    BLOCK_CONFIRMATION: "Möchten Sie diesen Benutzer wirklich sperren?",
    UNBLOCK_CONFIRMATION: "Möchten Sie diesen Benutzer wirklich entsperren? Beachtung!",
    UNBLOCK_WARNING: "Wenn Sie den Benutzer entsperren, werden alle Überstunden für den Zeitraum neu berechnet, in dem der Benutzer gesperrt wurde.",
    BLOCK: "Benutzer sperren",
    COUNTRY: "Land",
    CHANGETEAM :"Team wechseln",
    MON: "Mo",
    TUE: "Di",
    WED: "Mi",
    THU: "Do",
    FRI: "Fr",
    SAT: "Sa",
    SUN: "So",
    MONDAY: "Montag",
    TUESDAY: "Dienstag",
    WEDNESDAY: "Mittwoch",
    THURSDAY: "Donerstag",
    FRIDAY: "Freitag",
    SATURDAY: "Samstag",
    SUNDAY: "Sonntag",
    PASSWORD_TOOLTIP: "Das Passwort muss mindestens 8 Zeichen lang sein und mindestens ein Symbol und Großbuchstaben enthalten. z.B. sDejQ9*3",
    OFFER_DATA_ENTRY: "Dateneingabe anbieten",
    CALC_CLIENT_DATA_ACCESS: "Angebotsrechner - Mandantendaten",
    CALC_TEMPLATES_ACCESS: "Angebotsrechner - Vorlagen (nur anschauen)",
    CALC_TEMPLATES_EDIT_ACCESS: "Angebotsrechner - Vorlagen (bearbeiten)",
    CALC_OFFER_BUILDER_ACCESS: "Angebotsrechner - Angebotsersteller",
    CALC_GLOBAL_BIDS_ACCESS: "Angebotsrechner - globale Ausschreibung",
    CALC_PG_VIEW_ACCESS: "Angebotsrechner - Prozessgruppen (Aussicht)",
    CALC_PG_EDIT_ACCESS: "Angebotsrechner - Prozessgruppen (bearbeiten)",
    CALC_DIRECT_LOG_IN: "Angebotsrechner - Direkte Anmeldung",
    DIRECT_O_CLOGIN: "Angebotsrechner - Direkte Anmeldung",
    CANIMPORTINCOMECOUNTRYWIDE_TOOLTIP: 'Kann Umsätze importieren?" muss zuerst ausgewählt werden',
    EXPORT: "Datenexport",
    ACTIVE_FROM: "Gültig ab",
    WILL_BE_BLOCKED_AT: "Wird gesperrt bei",
    UNBLOCK: "Entsperren",
    CALC_GLOBAL_TENDER_MANAGER: "Global Tender Manager",
    ACCEPT_PERSONAL_WORKLOGS: "Kann eigene Worklog akzeptieren",
    INVOICED_TIME: "Invoicing time",
    PROJECT_VISIBILITY_FROM_D365: "D365 WBS Sichtbarkeitsbeschränkung",
    FORCE_POWER_USER: "Power user erzwingen"
  },
  BLOCKED_USERS: {
    TITLE: "Gesperrte Benutzer",
    SEARCH: "Vollständigen Namen eingeben",
    EDIT: "Bearbeiten",
    FULL_NAME: "Vollständigen Name",
    EMAIL_ADDRESS: "E-Mail-Adresse",
    ROLE: "Funktion",
    SENIORITY_LEVEL: "Mitarbeiterebene",
    TYPE: "Berichtstyp",
    STANDARD_WORKING_HOURS: "Standardarbeitsstunden",
    IS_ADMIN: "Ist Master-Admin?",
    IS_LOCAL_ADMIN: "Ist lokaler Admin?",
    IS_INTEGRATION_ADMIN: "Ist Integrations-Admin?",
    CAN_EDIT_ACCEPTED: "Aktualisierungen akzeptiert",
    CAN_EXPORT_WORKLOG: "Kann Worklog exportieren?",
    CAN_IMPORT_INCOME: "Kann Umsätze importieren?",
    CAN_IMPORT_INCOME_COUNTRYWIDE: "Kann Einkommen landesweit importieren?",
    CAN_UPDATE_RATES: "Kostensätze bearbeiten",
    CAN_VIEW_RATES: "Kostensätze anzeigen",
    MANAGEMENT_VIEW_HIDDEN: "Managementansicht ausgeblendet",
    CAN_ACCESS360_VIEW: "360 Ansicht",
    CAN_ACCESS_FLEXITIME: "Flexitime Ansicht",
    COUNTRY: "Land",
    BLOCKED_AT_F: "Gesperrt bei",
    VIEW: "Ansehen",
    UNBLOCK: "Entsperren",
    EXPORT: "Datenexport",
  },
  ADMIN_CLIENTS: {
    TITLE: "Mandanten",
    SEARCH: "Mandantennamen eingeben",
    NEW: "Neuen Mandanten hinzufügen",
    NAME: "Name der Rechtspersönlichkeit",
    TAX_ID: "Steuernummer",
    COUNTRY: "Land",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    NEW_CLIENT: "Neuer Mandant",
    EDIT_CLIENT: "Mandanten bearbeiten",
    DELETE_CLIENT: "Mandanten löschen",
    DELETE_CONFIRMATION: "Möchten Sie die KliX - Verbindung zum Mandanten wirklich entfernen?",
    VIEW: "Ansehen",
    CLIENT_GROUP_NAME: "Mandantengruppenbezeichnung",
    CLIENT_GROUP_ID: "Mandantengruppenbezeichnung",
    HAS_PROJECTS: "Projekte",
    VIEW_PROJECTS: "Projekte anzeigen",
    MDP_ID: "Master Data Portal ID",
    MDP_INFO: "Master Data Portal Name",
    MDP_NAME: "Master Data Portal Name",
    DOWNLOAD_CLIENT_NOTES: "Dokumentation",
    DEFAULT_BILLING_TYPE: "Default billing type",
    DEFAULT_BILLING_TYPE_NAME: "Default billing type",
    DEFAULT_BILLING_TYPE_ID: "Default billing type",
    MULTISELECT_KEYWORDS: "Multiselect",
    ADDITIONAL_INFO: "Zusätzliche informelle Vorsilbe",
    ADDITIONALINFO_TOOLTIP: "Diese Informationen haben keinen Einfluss auf die Funktionsweise der Anwendung, sie dienen lediglich der Information. Sie wird in Klammern angezeigt, wenn der Name des Kunden erscheint."
  },
  ADMIN_WAITING_CLIENTS: {
    TITLE: "Potentially duplicated clients",
    NAME: "Name",
    TAX_ID: "Tax ID",
    ACCEPT: "Accept",
    DECLINE: "Decline",
    SEARCH: "Type client name, tax ID or status",
    CLIENT_STATUSpe: "Status",
    FROM_MDP: "From MDP",
    POTENTIAL_DUPLICATES: "Potential duplicates",
    SHOW_DECLINED_CLIENTS: "Show declined clients",
    HIDE_DECLINED_CLIENTS: "Hide declined clients",
    EDIT_ORIGIN: "Edit origin client",
    CLIENT: "Client",
    PICK_ORIGIN_CLIENT: "Pick origin client"
  },
  PROJECTS: {
    TITLE: "Projekte",
    TEXT_ID: "Textbezeichner",
    NAME: "Name",
    FROM_DATE: "Von",
    TO_DATE: "Bis",
    NO_EXPIRATION_DATE: "Dieses Projekt hat kein Ablaufdatum",
    NO_EXPIRATION_DATE_SHORT: "Kein Ablaufdatum",
    ADD_NEW_PROJECT: "Neues Projekt erstellen",
    EDIT: "Bearbeiten",
    ARCHIVE: "Archivieren",
    ARCHIVE_CONFIRMATION: "Sind Sie sicher, dass Sie dieses Projekt archivieren wollen?",
    NEW_PROJECT: "Neues Projekt",
    CLIENT: "Mandant",
    EDIT_PROJECT: "Projekt bearbeiten",
    ARCHIVE_PROJECT: "Projekt archivieren",
    TOOLTIP_ERP: "Projekte werden automatisch aus dem ERP-System übernommen, um das Projekt zu bearbeiten, nehmen Sie notwendige Korrekturen direkt im Quell-ERP-System vor"
  },
  ARCHIVED_PROJECTS: {
    TITLE: "Archivierte Projekte",
    TEXT_ID: "Textbezeichner",
    NAME: "Name",
    FROM_DATE: "Von",
    TO_DATE: "Bis",
    RESTORE: "Wiederherstellen",
    RESTORE_CONFIRMATION: "Sind Sie sicher, dass Sie dieses Projekt wiederherstellen wollen?"
  },
  TEAM_CLIENTS: {
    TITLE: "Mandanten",
    SEARCH: "Mandantennamen eingeben",
    NEW: "Mandanten zuweisen",
    NAME: "Bezeichnung",
    TAX_ID: "Steuernummer",
    COUNTRY: "Land",
    EDIT: "Bearbeiten",
    REMOVE: "Entfernen",
    NEW_CLIENT: "Neuer Mandant",
    EDIT_CLIENT: "Mandanten bearbeiten",
    DELETE_CLIENT: "Mandanten löschen",
    DELETE_CONFIRMATION: "Möchten Sie diesen Mandanten wirklich löschen?",
    VIEW: "Ansehen",
    CLIENT_GROUP_NAME: "Mandantengruppenbezeichnung",
    CLIENT_GROUP_ID: "Mandantengruppenbezeichnung",
    EXPORT: "Datenexport",
    DOWNLOAD_CLIENT_NOTES: "Dokumentation",
    DEFAULT_BILLING_TYPE_NAME: "Default billing type",
    DISPLAY_NAME: "Bezeichnung"
  },
  CLIENT_GROUPS: {
    TITLE: "Mandantengruppen",
    SEARCH: "Mandantengruppenbezeichnung eingeben",
    NEW: "Neue Mandantengruppe hinzufügen",
    NAME: "Bezeichnung",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    NEW_CLIENT_GROUP: "Neue Mandantengruppe",
    EDIT_CLIENT_GROUP: "Mandantengruppe bearbeiten",
    DELETE_CLIENT_GROUP: "Mandantengruppe löschen"
  },
  SERVICE_LINES: {
    TITLE: "Geschäftsfelder",
    SEARCH: "Geschäftsfeldbezeichnung eingeben",
    NEW: "Neues Geschäftsfeld hinzufügen",
    NAME: "Bezeichnung",
    NEW_SERVICE_LINE: "Neues Geschäftsfeld"
  },
  SITES: {
    TITLE: "Standorte",
    SEARCH: "Standortbezeichnung eingeben",
    NEW: "Neuen Standort eingeben",
    NAME: "Bezeichnung",
    COUNTRY: "Land",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    NEW_SITE: "Neuer Standort",
    EDIT_SITE: "Standort bearbeiten",
    DELETE_SITE: "Standort löschen"
  },
  TEAMS: {
    TITLE: "Teams",
    SEARCH: "Teamnamen eingeben",
    NEW: "Neues Team hinzufügen",
    NAME: "Bezeichnung",
    SERVICE_LINE: "Geschäftsfeld",
    COUNTRY: "Land",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    NEW_TEAM: "Neues Team",
    EDIT_TEAM: "Team bearbeiten",
    DELETE_TEAM: "Team löschen",
    VIEW: "Ansehen",
    EXCLUDE_FROM_PROFITABILITY_REPORT: "Aus der Rentabilitätsansicht ausschließen",
    TEAM_NAME: "Teamname",
    WHEN: "Gültig ab",
    ARCHIVED: "Archiviert",
    EXPORT: "Datenexport",
    PROFIT_CENTER: "Profit center",
    PROFIT_CENTER_ID: "Profit center"
  },
  PROBLEMS: {
    TITLE: "Probleme",
    SEARCH: "Problembezeichnung eingebene",
    NEW: "Neues Problem hinzufügen",
    NAME: "Bezeichnung",
    DESCRIPTION: "Beschreibung",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    NEW_PROBLEM: "Neues Problem ",
    EDIT_PROBLEM: "Probem bearbeiten",
    DELETE_PROBLEM: "Problem löschen"
  },
  LICENSE_AGREEMENTS: {
    TITLE: "Lizenzvereinbarungen",
    SEARCH: "Namen angeben",
    NEW: "Neue Einladung",
    NEW_INVITATION: "Neue Einladung",
    CANCEL_INVITATION: "Einladung löschen",
    EMAIL: "E-Mail-Adresse",
    NAME: "Name",
    LEGAL_ROLE: "Rechtliche Rolle",
    LEGAL_ENTITY_ROLE: "Rolle der juristischen Person",
    STATUS: "Status",
    RESEND: "Erneut senden",
    CANCEL: "Abbrechen",
    DOWNLOAD: "Herunterladen",
    VIEW: "Ansehen",
    ACCEPTED: "Akzeptiert",
    WAITING: "Ausstehend",
    SUCCESS: {
      RESEND: "Die Einladung wurde erfolgreich erneut versendet.",
      SEND: "Einladung wurde erfolgreich gesendet."
    },
    CONFIRMATION: {
      RESEND: "Wollen Sie die Einladung unbedingt erneut versenden?",
      CANCEL: "Wollen Sie die Einladung unbedingt absagen?"
    }
  },
  LICENSE_AGREEMENT: {
    TITLE: "Lizenzvereinbarung",
    SUBHEADER: {
      DATA: "Rechnungsdaten",
      CONTACT: "Ansprechpartner",
      UPLOAD: "Dokument hochladen"
    },
    TAX_CERTIFICATE: "Steuerbescheinigung des Wohnsitzes erforderlich",
    COMPANY: "Firmenname",
    COUNTRY: "Land",
    ADDRESS1: "Adresse ",
    ADDRESS1_INFO: "(Straßenname, PLZ, Stadt/Ort)",
    INTRA_COMMUNITY_VAT_NUMBER: "USt-IdNr. für innergemeinschaftliche Zwecke",
    NO_INTRA_COMMUNITY_VAT: "Existiert nicht",
    LOCAL_VAT_NUMBER: "USt-IdNr. für lokale Zwecke",
    NO_LOCAL_VAT: "Existiert nicht",
    TAX_ID_NUMBER: "Steueridentifikationsnummer ",
    TAXIDNUMBER_INFO: "(sonstige Steueridentifikationsnummer)",
    PHONE_NUMBER: "Telefonnummer",
    INVOICES_EMAIL_ADDRESS: "E-Mail für Rechnungsversand",
    SEND: "Senden",
    ADD_FILE: "Dateien hinzufügen oder ein Dokument auswählen",
    CHANGE_FILE: "Dateien ändern",
    ADD_MORE_FILE: "Dateien hinzufügen",
    UPLOAD: "Hochladen",
    CONTACT_DATA: {
      MAIN_CONTACT_PERSON_NAME: "Name",
      MAIN_CONTACT_PERSON_EMAIL_ADDRESS: "E-Mail",
      MAIN_CONTACT_PERSON_PHONE_NUMBER: "Telefon"
    },
    TEXT: {
      UPLOAD: "Sie geben an, dass Sie befugt sind, eine bestimmte Einheit zu vertreten",
      TAX_CERTIFICATE: "Bitte ziehen Sie eine Absprache mit Ihrem Steuerberater in Erwägung, um festzustellen, ob Sie eine Ansässigkeitsbescheinigung benötigen."
    },
    LONG_TEXT: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce tempor molestie lacus vel efficitur. Mauris ornare sit amet tortor ac pellentesque. Donec tristique ut enim ac convallis. Maecenas ultrices mi eget urna sodales, at ultrices justo malesuada. Nullam et accumsan urna, sit amet tempor ipsum. Curabitur porta turpis a sem porttitor, id pulvinar augue ullamcorper. Morbi fringilla condimentum augue, eget molestie odio commodo non. Aliquam ac dui cursus, pharetra felis sit amet, pretium urna. Etiam aliquet massa vel felis varius venenatis.",
    CONSENTS: {
      YES: "Ja",
      NO: "Nein",
      LICENSE_AGREEMENT_ACCEPTED: "Lizenzvereinbarung akzeptieren",
      DATA_PROCESSING_AGREEMENT_ACCEPTED: "Vereinbarung zur Datenverarbeitung akzeptieren",
      ACCEPT: "",
      LICENSING: "Lizenzvereinbarung ",
      AGREEMENT: "akzeptieren"
    },
    THANK_YOU: {
      TEXT: "Vielen Dank! Die Kopie Ihrer Vereinbarung wurde an Ihre E-Mail gesendet.",
      CLOSE: "Schließen"
    }
  },
  USER: {
    TITLE: "Benutzer",
    EDIT: "Benutzer bearbeiten ",
    EDIT_USER: "Benutzer bearbeiten ",
    USER_LABEL: "Bezeichnung",
    USER_VALUE: "Wert",
    FULL_NAME: "Vollständiger Name",
    EMAIL_ADDRESS: "E-Mail-Adresse",
    ROLE: "Funktion",
    SITE_ID: "Standortbezeichnung",
    SENIORITY_LEVEL: "Mitarbeiterebene",
    STANDARD_WORKING_HOURS: "Standardarbeitsstunden",
    VALID_FROM: "Gültig ab",
    CAN_EDIT_ACCEPTED: "Aktualisierungen akzeptiert",
    CAN_EXPORT_WORKLOG: "Kann Worklog exportieren?",
    CAN_IMPORT_INCOME: "Kann Umsätze importieren?",
    CAN_IMPORT_INCOME_COUNTRYWIDE: "Kann Einkommen landesweit importieren?",
    CAN_UPDATE_RATES: "Kann Kostensätze aktualisieren?",
    CAN_VIEW_RATES: "Kann Kostensätze ansehen?",
    CAN_ACCESS360_VIEW: "360 Ansicht",
    CAN_ACCESS_FLEXITIME: "Flexitime Ansicht?",
    MANAGEMENT_VIEW_HIDDEN: "Managementansicht ausgeblendet",
    IS_ADMIN: "Ist Master-Admin?",
    IS_LOCAL_ADMIN: "Ist lokaler Admin?",
    IS_INTEGRATION_ADMIN: "Ist Integrations-Admin?",
    BLOCKED_AT: "Gesperrt bei",
    OFFER_DATA_ENTRY: "Dateneingabe anbieten",
    CANIMPORTINCOMECOUNTRYWIDE_TOOLTIP: 'Kann Umsätze importieren?" muss zuerst ausgewählt werden',
    RESEND_PASSWORD_LINK_1: "E-Mail zur Passwortänderung erneut senden",
    RESEND_PASSWORD_LINK_2: "oder den Link zur Passwordänderung kopieren",
    RESTRICTED_CLIENT_ACCESS: "Eingeschränkter Clientzugriff",
    L01: "L01 - non-Fee-Earner",
    L02: "L02 - Associate",
    L03: "L03",
    L04: "L04 - Senior Associate",
    L05: "L05",
    L06: "L06 - Manager",
    L07: "L07",
    L08: "L08 - Associate Partner",
    L09: "L09",
    L10: "L10 - Partner / Equity Partner / Shareholder",
    ACCEPT_PERSONAL_WORKLOGS: "Kann eigene Worklog akzeptieren",
    PROJECT_VISIBILITY_FROM_D365: "D365 WBS Sichtbarkeitsbeschränkung",
    INVOICED_TIME: "Invoicing time",
    FORCE_POWER_USER: "Power user erzwingen"
  },
  USERS_DIALOG: {
    TITLE: "Benutzer",
    EDIT: "Bearbeiten Benutzer",
    EDIT_USER: "Bearbeiten Benutzer",
    COUNTRY: "Land",
    TEAM_ID: "Teamname",
    USER_LABEL: "Bezeichnung",
    USER_VALUE: "Werte",
    FULL_NAME: "Vollständiger Name",
    EMAIL_ADDRESS: "E-Mail-Adresse",
    ROLE: "Funktion",
    SITE_ID: "Standortbezeichnung",
    SENIORITY_LEVEL: "Mitarbeiterebene",
    STANDARD_WORKING_HOURS: "Standardarbeitsstunden",
    VALID_FROM: "Gültig ab",
    CAN_EDIT_ACCEPTED: "Aktualisierungen akzeptiert",
    CAN_EXPORT_WORKLOG: "Kann Worklog exportieren?",
    CAN_IMPORT_INCOME: "Kann Umsätze importieren?",
    CAN_IMPORT_INCOME_COUNTRYWIDE: "Kann Einkommen landesweit importieren?",
    CAN_UPDATE_RATES: "Kann Kostensätze aktualisieren?",
    CAN_VIEW_RATES: "Kann Kostensätze ansehen?",
    CAN_ACCESS360_VIEW: "360 Ansicht",
    CAN_ACCESS_FLEXITIME: "Flexitime Ansicht?",
    MANAGEMENT_VIEW_HIDDEN: "Managementansicht ausgeblendet",
    IS_ADMIN: "Ist Master-Admin?",
    IS_LOCAL_ADMIN: "Ist lokaler Admin?",
    IS_INTEGRATION_ADMIN: "Ist Integrations-Admin?",
    BLOCK_USER: "Benutzer sperren",
    EDIT_BLOCKED_USER: "Gesperrten Benutzer bearbeiten",
    EDIT_TEAM: "Team bearbeiten",
    CURRENT_TEAM: "Bisheriges Team",
    NEW_TEAM_1: "Neues Team - erstes",
    NEW_TEAM_2: "Neues Team – zweites",
    CURRENT_DATE: "Current date",
    DATE: "Datum",
    TEAM_ID_STATIC: "Teamname",
    CANIMPORTINCOMECOUNTRYWIDE_TOOLTIP: 'Kann Umsätze importieren?" muss zuerst ausgewählt werden',
    SELECTED_DATES: "Datum auswählen",
    SELECT_DATE_PLACEHOLDER: "Datum auswählen",
    FROM: "von",
    TO: "bis",
    EXPORT_SYNC_PROBLEMS: "Sync-Probleme exportieren",
    ACTIVE_FROM: "Gültig ab",
    INVOICED_TIME: "Invoicing time",
    PROJECT_VISIBILITY_FROM_D365: "D365 WBS Sichtbarkeitsbeschränkung",
    FORCE_POWER_USER: "Power user erzwingen"
  },
  USER_OFFER_CALC: {
    FULL_NAME: "Full name",
    CALC_CLIENT_DATA_ACCESS: "Mandantendaten",
    CALC_TEMPLATES_ACCESS: "Vorlagen (nur anschauen)",
    CALC_TEMPLATES_EDIT_ACCESS: "Vorlagen (bearbeiten)",
    CALC_OFFER_BUILDER_ACCESS: "Angebotsersteller",
    CALC_GLOBAL_BIDS_ACCESS: "Globale Ausschreibung",
    CALC_PG_VIEW_ACCESS: "Prozessgruppen (Aussicht)",
    CALC_PG_EDIT_ACCESS: "Prozessgruppen (bearbeiten)",
    CALC_DIRECT_LOG_IN: "Direkte Anmeldung",
    DIRECT_O_CLOGIN: "Direkte Anmeldung",
    USER_LABEL: "Name",
    USER_VALUE: "Wert",
    EDIT_OC_ACCESS: "Zugansgrechte bearbeiten",
    EDIT_USER_OC_ACCESS: "Edit offer calculator access",
    TITLE: "Angebot Rechner Zugang",
    CALC_GLOBAL_TENDER_MANAGER: "Global tender manager",
  },
  RATES: {
    TITLE: "Kostensätze",
    SEARCH: "Nach Kostensatz, Mitarbeiterebene etc. durchsuchen",
    RATE: "Sätze",
    SENIORITY_LEVEL: "Mitarbeiterebene",
    SITE_NAME: "Standortbezeichnung",
    VALID_FROM: "Gültig ab",
    PROFIT_CENTER_NAME: "Profit center name",
  },
  API: {
    TITLE: "API-Schlüssel",
    SEARCH: "Suche nach Namen",
    NAME: "Name",
    ADD: "Neuen API key hinzufügen",
    REGENERATE: "Regenerieren",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    EDIT_VENDOR: "API-Schlüssel bearbeiten",
    DELETE_VENDOR: "API-Schlüssel löschen",
    NEW_VENDOR: "Neuer API-Schlüssel",
    EMAIL: "Email",
    IPS: "IPs",
    SITES: "Sites",
    USERS: "Benutzer",
    TEAMS: "Teams",
    EMPLOYEES: "Mitarbeiter",
    PROCESS_GROUPS: "Prozessgruppen",
    PROCESSES: "Prozesse",
    INTERRUPTS: "Interrupts",
    CLIENT_GROUPS: "Mandantengruppen",
    CLIENTS: "Mandanten",
    PROCESS_CLIENT_CONFIGURATIONS: "Verarbeiten von Client-Konfigurationen",
    INCOME: "Einkommen",
    WORKLOGS: "Worklogs",
    PROJECTS: "Projekte",
    SUCCESS: {
      REGENERATE: "Der API-Schlüssel wurde erfolgreich neu generiert."
    },
    CONFIRMATION: "Möchten Sie den API-Schlüssel wirklich erneut generieren?",
    IPADDRESSES_TOOLTIP: "Richtiges IP-Format, z. 198.51.100.1",
    IP_ADDRESSES_RANGES : "IP-Adressbereiche",
    IPADDRESSESRANGES_TOOLTIP: "Richtiges IP-Format, z. 198.51.100.1/24",
  },
  CLIENT_CONFIGUARTIONS: {
    DELETE_CONFIRMATION: "Möchten Sie diese Prozessgruppe mit Konfigurierungen wirklich löschen?",
    SEARCH: "Durchsuchen nach",
    COMMENT_REQUIRED: "Kommentar erforderlich?",
    HAS_VOLUME: "Hat Menge?",
    VALUE_ADDED: "Mehrwert?",
    EDIT: "Bearbeiten",
    NAME: "Local translation",
    ID_NAME: "Global name"
  },
  POSITIONS: {
    TITLE: "Positionen",
    NEW: "Neue Position hinzufügen",
    SEARCH: "Position nach Standortbezeichnung, Mitarbeiterebene etc. durchsuchen",
    SITE_NAME:"Standortbezeichnung",
    SENIORITY_LEVEL_NAME: "Mitarbeiterebene",
    TYPE: "Berichtstyp",
    VALID_FROM: "Gültig ab",
    VALID_FOR: "Gültig für",
    EDIT: "Bearbeiten",
    MON: "Standardarbeitsstunden",
    MOND: "Mo",
    TUE: "Di",
    WED: "Mi",
    THU: "Do",
    FRI: "Fr",
    SAT: "Sa",
    SUN: "So"
  },
  POSITION: {
    ADD_POSITION: "Neue Position hinzufügen",
    EDIT_POSITION: "Position bearbeiten",
    SITE_ID: "Standortbezeichnung",
    WORKNORM: "Regelarbeitszeit",
    LONGTERMLEAVE: "Langzeiturlaub",
    HOURLYNORM: "Stundenbasiert",
    SENIORITY_LEVEL: "Mitarbeiterebene",
    STANDARD_WORKING_HOURS: "Standardarbeitsstunden",
    HOURLY_WORKING_HOURS:"Stundenarbeitsnorm.",
    HOURLYWORKINGHOURS_TOOLTIP: "Basierend auf einem faktischen Zeitbericht ohne Über- oder Minusstunden und ohne Regelarbeitszeit.",
    STANDARDWORKINGHOURS_TOOLTIP: "Basierend auf traditionellem Regelarbeitszeit-Ansatz mit Minus- und Überstunden, die anhand gemeldeter Daten berechnet werden.",
    TYPE: "Berichtstyp",
    VALID_FROM: "Gültig ab",
    MON: "Mo",
    TUE: "Di",
    WED: "Mi",
    THU: "Do",
    FRI: "Fr",
    SAT: "Sa",
    SUN: "So"
  },
  TEAM_CLIENT: {
    VALUES: {
      TITLE: "Werte",
      ADD_PROCESSES: "Neue Prozesse hinzufügen",
      CLIENT_LABEL: "Wertbezeichnung",
      CLIENT_VALUE: "Wert"
    }
  },
  RESTRICTED: {
    IS_ALLOWED: "ist erlaubt?",
    CLIENT_NAME: "Mandant",
    TITLE: "Mandanten Zugriff",
    SEARCH: "Mandanten nach eingeschränktem Zugriff suchen",
    EDIT_ACCESS: "Zugriff ändern",
  },
  CLIENT_PROCESS: {
    EDIT_PROCESS: "Prozess bearbeiten",
    COMMENT_REQUIRED: "Kommentar erforderlich?",
    HAS_VOLUME: "Hat Menge?",
    VALUE_ADDED: "Mehrwert?",
    DELETE_PROCESS: "Prozessgruppe löschen",
    NEW_PROCESS_GROUP: "Hinzufügung neuer Prozessgruppen-Konfigurierungen",
    OTHER_PROCESS_GROUPS: "Andere Prozessgruppen-Konfigurierungen:",
    NAME: "Local translation",
    ID_NAME: "Global name",
    DESCRIPTION: "Beschreibung",
    ADD: "Hinzufügen",
    REMOVE: "Entfernen",
    NOTHING_MORE: "Es kann nichts mehr hinzugefügt werden",
    MAIN_TITLE_TOOLTIP: "Konfigurieren Sie die Prozessstruktur mit Volume- und VA / NVA-Markierungen gemäß Service Level Agreement"
  },
  ADD_SOMETHING: "Füge einige Daten hinzu",
  TEAM: {
    NEW_CLIENT: "Neue Mandantenkonfigurierung",
    CLIENT: "Mandant",
    SUGGESTED_PGC: "Vorgeschlagene Prozessgruppenkonfigurierungen:",
    NAME: "Bezeichnung",
    DESCRIPTION: "Beschreibung",
    ADD_REMOVE: "Hinzufügen/Entfernen",
    ADD: "Hinzufügen",
    REMOVE: "Entfernen",
    UNUSED_PGC: "Ungenutzte Prozessgruppen-Konfigurierungen:",
    PROCESS_GROUP_CONFIGURATIONS: "Prozessgruppen-Konfigurierungen:",
    INTERNAL_CONFIGURATIONS: "Interne Konfigurierungen",
    ASSIGN: "Zuweisen",
    MARK_CLIENT: "Zuzuweisende Mandanten markieren oder alle auswählen",
    CLIENTS_SELECTED: "Ausgewählt",
    SELECT_ALL: "Alle auswählen",
    NO_CLIENTS: "Es gibt keinen Mandanten mit diesem Namen",
    SEARCH: "Mandantenname eingeben"
  },
  OVERTIME_MANAGEMENT: {
    TITLE: "Überstundenmanagement",
    SEARCH: "Nach Datum oder Modus durchsuchen",
    NEW: "Neuer Überstundenmodus",
    EDIT: "Bearbeiten",
    EDIT_OVERTIME: "Überstunden bearbeiten",
    VALID_FROM: "Gültig ab",
    MODE: "Modus",
    MANAGEMENT_MODE: "Modus",
    NEW_OVERTIME: "Neuen Überstundenmodus hinzufügen"
  },
  ADMIN_CLIENT: {
    NAME: "Bezeichnung",
    TAX_ID: "Steuernummer",
    COUNTRY: "Land",
    GROUP_NAME: "Group name",
    DEFAULT_BILLING_TYPE: "Default billing type",
    MULTISELECT_KEYWORDS: "Multiselect",
    ADDITIONAL_INFO: "Zusätzliche informelle Vorsilbe"
  },
  PROFIT_CENTER_RATES: {
    RATES: "Sätze",
    SELECT_PROFIT_CENTER: "Profit Center auswählen",
    PROFIT_CENTERS: "Profit Centers",
    ADD_RATE: "Neuen Stundensatz hinzufügen",
    ADD_NEW_LEVEL: "Neuen Karrierestufen Stundensatz",
    VALID_FROM: "Gültig ab",
    CURRENT_RATES: "Aktuelle Sätze",
    ERROR: "Speichern nicht möglich. Überprüfen Sie die Daten!",
    ARCHIVAL_RATES: "Archivierte Sätze",
    UPDATED_ARCHIVED_RATE: "Aktualisieren Sie den archivierten Satz",
    SENIORITY_LEVEL: "Mitarbeiterebene",
    L01: "L01 - non-Fee-Earner",
    L02: "L02 - Associate",
    L03: "L03",
    L04: "L04 - Senior Associate",
    L05: "L05",
    L06: "L06 - Manager",
    L07: "L07",
    L08: "L08 - Associate Partner",
    L09: "L09",
    L10: "L10 - Partner / Equity Partner / Shareholder",
    NULL_ERROR: "Mindestens ein Feld ist leer. Füllen Sie die fehlenden Felder aus."
  },
  CONTROLLING: {
    INCOME_IMPORT: "Bereiten Sie die Einnahmen vor",
    SELECT_PROFIT_CENTERS: "Wählen Sie die Profit Centers aus",
    SELECT_TEAMS_FOR_IMPORT: "Wählen Sie die Teams, um das Einnahmen-Arbeitsblatt zu importieren in:",
    SELECT_TEAMS_FOR_EXPORT: "Wählen Sie die Teams, um die Daten zu exportieren aus:",
    SELECT_YEAR: "Wählen Sie das Jahr aus:",
    SELECT_MONTH: "Wählen Sie den Monat aus:",
    SELECT_TEAM_AND_PERIOD: "Wählen Sie die Teams und die Monate aus",
    SELECT_PERIOD: "Wählen Sie den Zeitraum aus",
    SELECT_SITES: "Wählen Sie die Standorte aus",
    SELECT_SERVICE_LINES: "Wahlen Sie die Geschäftsfelder aus",
    DOWNLOAD_TEMPLATE: "Schnittstellendatei herunterladen",
    DOWNLOAD: "Daten herunterladen",
    UPLOAD_INCOME_EXCEL: "Umsatz-Excel- Datei hochladen",
    FETCH_INCOME_CASEMAN: "Download income from CASEman",
    FETCH_INCOME_REPORT: "Download synchronization report",
    TEAM_INCOME: "Umsatz des Teams",
    TAX_ID: "Steuerliche Identifikationsnummer",
    INCOME: "Umsatz",
    INCOME_EXCLUDE_NO_TIME: "(nur Mandanten mit Zeitangabe)",
    INCOME_NO_TIME: "(Mandanten mit Umsatz aber ohne gemeldete Zeit)",
    ERROR_UPLOADING: "Fehler beim Hochladen der Excel-Datei",
    EXPORT: "Datenexport",
    DATE_START: "Start date",
    DATE_END: "End date",
    SELECT_FIELDS: "Wählen Sie die Datenfelder aus, die Sie exportieren wollen:",
    NO_SUBTEAMS_WARNING: "Sie haben keine untergeordneten Teams",
    NO_SUBTEAMS: "Sie haben keine untergeordneten Teams für solche Kriterien",
    INCLUDE_ALL: "Schließen Sie alle Mandanten ein, die Teams zugeordnet sind",
    EXCLUDE_NO_TIME: "Mandanten ohne gemeldete Zeit ausblenden",
    NO_TIME_REPORTED: "Keine Zeit gemeldet",
    TEAM_S: "Team(s)",
    ERROR_NOTES: {
      WRONG_NUMBER_COLUMNS: "Falsche Anzahl von Spalten",
      NO_CLIENT_OR_TEAM: "Mandant oder Team in income xlsx konnte nicht gefunden werden",
      NO_VALID_NUMBER: "Die Mengenzelle ist keine gültige Zahl. Ändern Sie entweder den Spaltentyp der Zelle in eine Zahl oder lassen Sie den Betrag so aussehen: 134444.56",
      CANT_CONVERT: "Bei der Konvertierung ist ein Fehler aufgetreten",
      UPLOAD_FAILED: "Upload xlsx Einkommen fehlgeschlagen",
      WRONG_NAME_FORMAT: "Der Dateiname hat ein falsches Format",
      INVALID_FORMAT: "Ungültiges Dateiformat"
    }
  },
  ADMIN_RATES: {
    TITLE: "Profit Center",
    SEARCH: "Search by country, site name, etc.",
    COUNTRY: "Land",
    SITE_NAME: "Standortbezeichnung",
    SENIORITY_LEVEL: "Mitarbeiterebene",
    RATE: "Sätze",
    VALID_FROM: "Gültig ab",
    PROFIT_CENTER_NAME: "Profit Center name",
    SENIORITY_LEVEL_NAME: "Mitarbeiterebene"
  },
  MANAGEMENT: {
    VIEW_HEADER: "Management - Ansicht",
    COUNTRIES: "Wählen Sie die Länder aus",
    PROFIT_CENTERS: "Wählen Sie die Profitcenter aus",
    SITES: "Wählen Sie die Standorte aus",
    SERVICE_LINES: "Wählen Sie die Geschäftsfelder aus",
    TEAMS: "Wählen Sie die Teams aus",
    START_DATE: "Startdatum",
    END_DATE: "Enddatum",
    DOWNLOAD: "Herunterladen",
    ERROR: "Fehler beim Herunterladen! Prüfen Sie, wenn 'das Enddatum nicht in der Vergangenheit liegt'",
    SELECT_ALL: "Wählen Sie alles aus"
  },
  DIALOG_CARD: {
    COMMENT_REQUIRED: "Kommentar erforderlich",
    COMMENT_NOT_REQUIRED: "Kommentar nicht erforderlich",
    ALL_COMMENTS_REQUIRED: "Stellen Sie alle erforderlichen Kommentare ein",
    ALL_COMMENTS_NOT_REQUIRED: "Stellen Sie alle nicht erforderlichen Kommentare ein",
    CONFIRMATION_TEXT: "Die Änderung gilt nur für bereits erstellte Instanzen. Denken Sie daran, dass neue Instanzen mit den aktuellen Einstellungen erstellt werden. Stellen Sie sicher, dass Sie Ihre Einstellungen nicht aktualisieren müssen.",
    HAVE_VOLUME: "Have volume",
    HAVE_NOT_VOLUME: "have not volume",
    ALL_HAVE_VOLUME: "All have volume",
    ALL_HAVE_NOT_VOLUME: "All have not volume",
    HAVE_VALUE_ADDED: "Have value added",
    HAVE_NOT_VALUE_ADDED: "have not value added",
    ALL_HAVE_VALUE_ADDED: "All have value added",
    ALL_HAVE_NOT_VALUE_ADDED: "All have not value added",
    WARNING_LABEL: "WARNUNG",
    CONFIRM: "Bestätigen",
    BLOCKED: "Bitte ändern Sie die Daten!",
    SAME_TAX_ID: "Diese STEUER-ID ist bereits im Client vorhanden: ",
    CHANGE_IT: "Bitte ändern Sie es!",
    SAME_CLIENT_NAME: "Dieser NAME existiert bereits.",
    SIMILAR_NAMES: "Client(s) mit ähnlichem Namen sind bereits vorhanden.",
    CHANGE_AND_CONFIRM: "Bitte ändern Sie es oder bestätigen Sie Duplikate, indem Sie auf 'Senden' klicken!",
    SIMILAR_CLIENTS: "Ähnlichkeiten:",
  },
  CASEMAN: {
    ACTIVE_TOOLTIP: "Inaktive Mandanten sind solche, gegen die innerhalb der letzten 6 Monate keine Zeit gemeldet wurde, gezählt ab dem aktuellen Monat",
    ADD_EXCEPTION: "Ausnahme hinzufügen",
    ALL: "Alles",
    ALL_TO_SETTLE: 'Alle "zu erledigen"',
    ALL_NOT_TO_SETTLE: 'Alle "nicht zu erledigen"',
    VA_TO_SETTLE_NVA_NOT: 'VA bis "zu regeln", NVA bis "nicht zu regeln"',
    CASEMAN: "Caseman",
    CLIENT_CASEMAN: "Mandant (CASEMAN)",
    CLIENT_CONFIG_ERP: "Mandanten",
    CLIENT_CONFIG: "Mandantenkonfiguration",
    CLIENT_KLIX: "Mandant (KliX)",
    CLIENT: "Mandant",
    CLIENTS_KLIX: "Mandanten in KliX",
    CONFIG: "Konfiguration",
    CONFIGURE_TEAM: "Keine Teamkonfiguration. Sie müssen zuerst eine Teamkonfiguration erstellen.",
    COUNTRY: "Land",
    CURRENT_STRATEGY: "Ihre aktuelle Strategie ist:",
    CURRENT_TEAM: "Aktuelles Team: ",
    DELETE: "Löschen",
    EDIT: "Bearbeiten",
    EXCEPTIONS: "Ausnahmen",
    EXPORT_SYNC_PROBLEMS: "Synchronisationsprobleme exportieren",
    FROM: "Von",
    HIDDEN: "[versteckt]",
    INCOME_OVERWRITE: "Für das angegebene Datum sind Einnahmen definiert. Das Abrufen von Einnahmen kann vorhandene Daten überschreiben. Fortfahren?",
    INTEGRATION_SETTINGS: "Integrationseinstellungen",
    INTERRUPT_KLIX: "Unterbrechung (KliX)",
    INTERRUPT: "Unterbrechung",
    INTERRUPTS: "Unterbrechungen",
    JOBCODE_CASEMAN: "Jobcode (CASEMAN)",
    JOBCODE: "Jobcode",
    MATCH: "Abgleichen",
    MATCHING_CLIENT: "Mandanten (KliX)",
    MATCHING_ERP: "Anpassung",
    MATCHING_INTERRUPTS: "Abgleich von Unterbrechungen KliX und Projekt CASEMAN",
    MATCHING_PROJECTS: "Abgleichprozess KliX und Projekt CASEMAN",
    MATCHING: "Abgleich",
    NO_CLIENTS: "In diesem Land gibt es keine Mandanten",
    NO_PROJECTS_AVAILABLE: "Keine Projekte verfügbar",
    NO_PROJECTS: "Keine Projekte",
    NO_TEAM_INFO: "Es wurde kein Team zugeordnet. Bitte kontaktieren Sie den Integrationsadministrator.",
    ONLY_ACTIVE: "Nur aktive Mandanten anzeigen",
    PG_CONFIG_ERP: "Prozessgruppen und Prozesse",
    PG_CONFIG: "Prozessgruppenkonfiguration",
    PROCESS_FOR_PG: "Prozess für Prozessgruppe",
    PROCESS_GROUP_KLIX: "Prozessgruppe (KliX)",
    PROCESS_GROUP: "Prozessgruppe",
    PROCESS_GROUPS: "Prozessgruppen in KliX",
    PROCESS_KLIX: "Prozess (KliX)",
    PROCESS: "Prozess",
    PROJECT_CASEMAN: "Projekt (CASEMAN)",
    PROJECT_CONFIG: "Projektkonfiguration",
    PROJECT: "Projekt",
    PROJECTS: "Projekte",
    ROOT_CONFIG: "CASEMAN-Wurzelkonfiguration",
    SELECT_DATE_PLACEHOLDER: "Datum wählen",
    SELECT_PROCESS_GROUPS: "Prozessgruppe auswählen",
    SELECT_PROCESS: "Prozess auswählen",
    SELECT_PROJECT: "Projekt auswählen",
    SELECTED_DATES: "Datum wählen",
    SHOW_HIDDEN: "Versteckte Prozesse anzeigen",
    SITE_CASEMAN: "Standort (CASEMAN)",
    SITE_KLIX: "Standort (KliX)",
    SITE: "Standort",
    SITES_KLIX: "Standorte (KliX)",
    SITES: "Standorte",
    SUBCODE_CASEMAN: "Subcode (CASEMAN)",
    SUBCODE: "Subcode",
    SYNC: "Synchronisieren",
    TEAM_CASEMAN: "Team CASEMAN",
    TEAM_CONFIG_ERP: "Teams",
    TEAM_CONFIG: "Teamkonfiguration",
    TEAM_KLIX: "Team KliX",
    TEAM: "Team",
    TEAMS_CASEMAN: "Teams CASEMAN",
    TEAMS_KLIX: "Teams KliX",
    TO: "Bis",
    USER_CASEMAN: "Benutzer (CASEMAN)",
    USER_CONFIG_ERP: "Benutzer",
    USER_CONFIG: "Benutzerkonfiguration",
    USER_KLIX: "Benutzer (KliX)",
    USER: "Benutzer",
    USERS_KLIX: "Benutzer in KliX"
  },
  CASEMAN_SYNC: {
    AGGREGATE_JOBCODE: "Mandant-Jobcode",
    AGGREGATE_PROCESS: "KliX-Prozess",
    AGGREGATE_PROJECT_JOBCODE: "CASEMAN Projekt-Jobcode",
    AGGREGATE_TYPE: "Aggregationstyp: ",
    AUTO_SYNC_FOR_ALL: "Automatische Synchronisierung für alle Benutzer",
    AUTOSYNC_TOOLTIP: "Der AUTO-Modus sendet die Daten des aktuellen Tages automatisch an CASEman. Dies geschieht täglich um 23.30 Uhr. Bitte beachten Sie, dass Änderungen an früheren Tagen manuell synchronisiert werden müssen.",
    AUTOSYNC: "Automatisch",
    CHECK_ALL: "Alle überprüfen",
    CHECK: "Überprüfen",
    CLIENT: "Mandant",
    COMMENT: "Kommentar",
    COUNTRY: "Land",
    CUSTOMIZATION: "Personalisierung",
    DATE: "Datum",
    DEAD: "Caseman funktioniert nicht.",
    DONE: "Fertig",
    DURATION: "Gerundete Dauer",
    FAIL: "Fehlschlagen",
    FAILED: "Gescheitert",
    FROM: "Von",
    INVOICE_DETAILS: "Rechnungsdetails",
    JOBCODE: "Jobcode",
    MINUTES: "Minuten",
    NO_PACKAGES: "Im gewählten Zeitraum gibt es keine Pakete.",
    NOT_SENT: "Nicht gesendet",
    OFF: "Aus",
    ON: "An",
    PAID: "Bezahlt/Nicht bezahlt",
    PICK_DATES: "Datum wählen",
    PROBLEM: "Problem",
    PROJECT: "Projekt",
    REPORT_LANGUAGE: "Berichtssprache",
    SEND_REPORTS_TOOLTIP: "Die Funktion 'Berichte senden' versendet einen Bericht über Daten, die nicht automatisch mit CASEman synchronisiert wurden",
    SEND_REPORTS: "Berichte senden",
    SHOW_PROCESS_GROUPS_MAPPINGS: "Jobcode-Zuordnungen in Tooltips für Prozessgruppen anzeigen",
    SHOW_PROCESSES_MAPPINGS: "Jobcode-Zuordnungen in Tooltips für Prozesse anzeigen",
    STATS: "Stats",
    STATUS: "Status",
    SUBCODE: "Subcode",
    SUCCESS: "Erfolg",
    SYNC: "Sync",
    TO: "Bis",
    WORKLOGS_INFO: "KliX Arbeitsprotokolle im Paket enthalten"
  },
  SEARCH_AND_SELECT: {
    NO_DATA: "keine Daten"
  },
  TOOLTIP: {
    COUNTRY_FEATURE_FLAG_TOOLTIP: "Bitte kontaktieren Sie den Master-Administrator, um diese Änderungen vorzunehmen",
    COUNTRY_CLIENT_GROUP_NAME_TOOLTIP: "Bitte kontaktieren Sie den Master-Administrator, um neue Mandantengruppen anzulegen, die nicht auf Ihrer Länderliste stehen",
    COUNTRY_CLIENT_ACTION_TOOLTIP: "Bitte kontaktieren Sie den Master-Administrator, um einen Mandanten zu löschen",
    LOCAL_NAME_TOOLTIP: "Die lokale Übersetzung muss strikt auf den globalen Namen abgestimmt sein",
    MAIN_TITLE_TOOLTIP: "Prozessstruktur mit dem jeweiligen Umfang und der VA/NVA-Kennzeichnung gemäß dem Service Level Agreement konfigurieren",
    LOCAL_DESCRIPTION_TOOLTIP: "Lokale Übersetzungen werden im Prozess-Tooltip angezeigt",
    OPPORTUNITY_TIME_TOOLTIP: "Kontaktieren Sie den Master-Administrator, um die Konfiguration der Opportunity-Zeit zu ändern",
    NO_INCOMES_UPLOADED: "Keine Einkünfte hochgeladen"
  },
  SUBMENU: {
    WORK_DATA: "Arbeitsdaten",
    WORKLOGS: "Worklogs",
    POWER_USER: "Power user",
    DAILY_REPORT: "Tagesbericht",
    PROFITABILITY: "Rentabilität",
    OVERTIME: "Überstunden",
    EXPORT: "Export",
    FLEXITIME: "Flexitime",
    VIEW_360: '360 Ansicht',
    OVERIME_APPLICATION: "Überstundenantrag"
  },
  VIEW360: {
    AVERAGE_TIME_PER_UNIT: "Durchschnittliche Zeit pro Einheit",
    BY: "By",
    DOWNLOAD_TO_EXCEL: "Datenexport",
    MANAGE_SHARES: "Freigaben Verwalten",
    PROCESS_GROUPS: "Prozessgruppen",
    PROCESS_PROBLEMS: "Prozessprobleme",
    EMPLOYEE_ROLE: "Mitarbeiter Rolle",
    ENABLED: "Aktiviert",
    ENABLE_WORKLOG_EXPORT: "Arbeitsprotokoll-Export aktivieren",
    EXPORT: "Datenexport",
    HIDDEN: "Versteckt",
    MORE: "MEHR",
    OTHERS: "Keine Mandantengruppe",
    RANGE_TOO_SMALL: "Ausgewählter Datumsbereich ist zu klein. Wählen Sie mindestens zwei Monate.",
    SELECT: "Auswählen",
    SELECT_PROCESS: "Wählen Sie einen Prozess in der Volumenanalysetabelle",
    SHARE: "Teilen",
    SHARE_VIEW_AS_LINK: "Teilen",
    SHARE_EXPIRE: "Dieser Link ist nur für 7 Tage aktiv.",
    SHOW: "ANZEIGEN",
    SHOW_LESS: "WENIGER ANZEIGEN",
    TOGGLE_ALL: "Alle auswählen",
    VOLUME_SLICER_TABLE: "'Slice & Dice' Volumentabelle",
    EXPIRED_MESSAGE: "Der angegebene Link ist abgelaufen. Bitte kontaktieren Sie die Person, die den Link zur Verfügung gestellt hat, um weitere Informationen zu erhalten.",
    SHOW_WORKLOG: "Arbeitsprotokoll-Tabelle anzeigen",
    SHOW_CHART: "Diagramm-Tabelle anzeigen",
    SET_NAME: "Freigabename festlegen",
    SHOW_ZERO_VOL: "Prozesse ohne Inhalt anzeigen",
    EMPLOYEES: "Mitarbeitende",
    CLIENT_GROUPS: "Mandantengruppen",
    COPY: "In die Zwischenablage kopieren.",
    COPIED: "In die Zwischenablage kopiert.",
    CURRENCY: {
      APPLIED: "Neue Währung angewendet",
      NEGATIVE_NUMBER: "Das Währungsverhältnis kann nicht negativ sein",
      QUESTION_PART1: "Der aktuellste verfügbare Wechselkurs ist der vom ",
      QUESTION_PART2: ". Akzeptieren Sie?",
      QUESTION_TWO_DATES_1: "Die aktuellsten verfügbaren Wechselkurse sind vom ",
      QUESTION_TWO_DATES_2: ". Wählen Sie ein Datum aus.",
      APPLIED_BUTTON: "Anwenden",
      LIVE: "Live",
      FIXED_DATE: "Festes Datum",
      FIXED_RATE: "Fester Kurs",
      EXCHANGE_RATE: "Wechselkurs:",
      SOURCE: "Quelle:"
    },
    MODAL: {
      EDIT: "Bearbeiten",
      SHARES: "FREIGABEN",
      CREATED: "ERSTELLT",
      EXPIRES: "ABLÄUFT",
      VIEWS: "ANSICHTEN",
      STATUS: "STATUS",
      ACTIONS: "AKTIONEN",
      ACTIVATE: "Aktivieren",
      DEACTIVATE: "Deakivieren",
      ACTIVE: "Aktivieren",
      INACTIVE: "Deakivieren",
      ERROR_DATE: "Abgelaufenes Datum liegt vor dem Erstellungsdatum, Änderung wird nicht übernommen",
      SUCCESS_DATE: "Time successfully extended to ",
      SUCCESS_DATE_END: " verlängert",
      SUCCESS_RESTORED: "Erfolgreich wiederhergestellt und für 7 Tage verlängert",
      QUESTION: "Link ablaufen lassen?",
      QUESTION_DELETE: "Sind Sie sicher, dass Sie löschen möchten?",
      YES: "JA",
      NO: "NEIN",
      SUCCESS_EXPIRED: "Erfolgreich auf den Zustand verfallen gesetzt",
      SUCCESS_SAVED: "Speichern",
      SUCCESS_ALLOCATION: "Erfolgreich zugeordnet"
    },
    WIDGETS: {
      TOTAL_TIME: "Zeitaufwand",
      TOTAL_TIME_DESC: "Summe der Mitarbeiter, die für bestimmte Mandaten für ausgewählte Teams im ausgewählten Zeitbereich gearbeitet haben",
      PROFITABILITY_DESC: "Effektive Rentabilitätsrate für bestimmte Mandaten für ausgewählte Teams im ausgewählten Zeitbereich",
      HOURLY_RATE: "Stundensatz",
      HOURLY_RATE_DESC: "Effektiver Stundensatz für bestimmte Mandaten für ausgewählte Teams im ausgewählten Zeitbereich",
      TOTAL_TURNOVER: "Gesamtumsatz",
      TOTAL_TURNOVER_DESC: "Summe der Einnahmen für bestimmte Mandaten für ausgewählte Teams im ausgewählten Zeitbereic",
      VA_DESC: "Prozentualer Zeitaufwand für Prozesse im Rahmen des regulären Vertrags (Wertschöpfung) für bestimmte Mandanten für ausgewählte Teams im ausgewählten Zeitraum",
      NVA_DESC: "% der Zeit, die für Prozesse außerhalb des regulären Vertrages aufgewendet wurde (Non value added) für bestimmte Mandanten für ausgewählte Teams im ausgewählten Zeitbereich",
      TOTAL_COST: "Team(s) Gesamtkosten",
      TOTAL_COST_DESC: "Summe der multiplizierten Zeiten und der Stundensätze auf Mitarbeiterebene",
      TOTAL_MARGIN: "Gesamtumsatz abzüglich der Gesamtkosten",
      TOTAL_MARGIN_DESC: "Gesamtumsatz abzüglich der Gesamtkosten",
    }
  },
  FLEXITIME: {
    ACCEPTANCE_FILTER: "Akzeptanz Filter",
    TYPE_FILTER: "Typ Filter",
    CLIENT_FILTER: "Mandant Filter",
    CLIENT_GROUP_FILTER: "Mandant Gruppe Filter",
    NEW_WORKLOG: "Neuen Worklog hinzufügen",
    EDIT_WORKLOG: "Worklog bearbeiten",
    DELETE_WORKLOG: "Worklog löschen",
    DATE: "Datum",
    START_AT: "Fange an bei",
    DURATION: "Dauer",
    HH_MM: "[hh:mm]",
    CLIENT_NAME: "Mandantenname",
    SERVICE_LINE: "Serviceline",
    PROCESS_GROUP: "Prozessgruppe",
    PROCESS: "Prozess",
    STATUS: "Status",
    ADD_NEW: "Neue hinzufügen",
    INTERRUPT: "Unterbrecher",
    STATUSES: {
      STARTED: "Gestartet",
      FINISHED: "Fertig",
      ERROR: "Error",
    },
    WORKLOG_COPIED: "Worklog in Zwischenablage kopiert.",
    PASTE_OR: "Wählen Sie den Ort zum Einfügen aus oder klicken Sie auf ",
    ESC: "ESC",
    TO_ABORT: ", um den Vorgang abzubrechen",
    PASTE: "Hier einfügen",
    ADD_NEW_PROCESS: "Neu Prozess",
    ADD_NEW_INTERRUPT: "Neu Unterbrecher",
    REALLY: "Willst du wirklich abbrechen?",
    CHANGES_WILL_LOST: "Alle nicht gespeicherten Änderungen gehen verloren.",
    UNSAVED_WARNING: "Du hast nicht gespeicherte Änderungen. Möchten Sie trotzdem den Standort wechseln? (Wenn Sie auf OK klicken, werden alle nicht gespeicherten Arbeitsprotokolle abgebrochen.)",
    SPLIT_MODAL: {
      DESCRIPTION: "Reported time exceeds the overall time for the request. Do you want to split the reported time into a request and a normal worklog?",
      NO_DESCRIPTION: 'If you choose "No", you have to edit this worklog before save.',
      YES: "Yes",
      NO: "No"
    }
  },
  SUBSCRIPTIONS: {
    TITLE: "Mitteilungen",
    NEW: "Neue Mitteilung hinzufügen",
    ADD_SUBSCRIPTION: "Mitteilung hinzufügen",
    EDIT_SUBSCRIPTION: "Mitteilungen bearbeiten",
    DELETE_SUBSCRIPTION: "Mitteilung löschen",
    TABLES: "Tabellen",
    SEND_AT_MONTH_DAY: "Bericht an jeden",
    SEND_AT: "Senden am",
    EVERY_DAY: "Tag des Monats senden",
    OVERTIME: "Overtime",
    PROFITABILITY: "Rentabilität",
    HOURLY_RATE: "Stündlich",
    DURATION: "Dauer",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    SEND_SUBSCRIPTION: "Mitteilung senden",
    DAY: "Tag",
    ADD_BUTTON_TOOLTIP: "Im Moment ist es möglich, nur ein Abonnement hinzuzufügen",
    LANGUAGE: "Sprache",
    CURRENCY: "Währung",
    CURRENCY_NAME: "Währung",
    LOCAL: "Lokal",
    LONG_TERM_REPORT_TWELVE_MONTHS: "Durchschnitt",
    LONG_TERM_REPORT_TWELVE_MONTHS_INFO: "Durchschnitt",
    SIX_MONTHS: "6 Monate",
    TWELVE_MONTHS: "12 Monate",
    TEAM: "Überstunden",
    OVERTIME_SUBSCRIPTION: "Überstunden",
    PROFITABILITY_SUBSCRIPTION: "Rentabilität",
    PROFITABILITY_SUBSCRIPTION_BUTTON: "Mitteilung für Rentabilität",
    OVERTIME_SUBSCRIPTION_BUTTON: "Mitteilung für Überstunden",
    LEGAL_ALERT: "Legal",
    TEAM_NAME: "Überstundenantrag-Team",
    TEAM_ID: "Team",
    ALL_TEAMS: "Alle Teams",
  },
  OVERTIME_SUBSCRIPTIONS: {
    TITLE: "Mitteilungen",
    NEW: "Neue Mitteilung hinzufügen",
    ADD_SUBSCRIPTION: "Mitteilung hinzufügen",
    EDIT_SUBSCRIPTION: "Mitteilungen bearbeiten",
    DELETE_SUBSCRIPTION: "Mitteilung löschen",
    EMPLOYEE: "Mitarbeiter-Tabelle ",
    TEAM_TABLE: "Team-Tabelle ",
    ORDER_BY: "Hauptmaßnahme",
    ROWS: "Zeilen",
    TEAM_ACCEPTED_OVERTIME_THRESHOLD: "Schwellenwert für akzeptierte Überstunden",
    TEAM_REPORTED_OVERTIME_THRESHOLD: "Schwellenwert für gemeldete Überstunden",
    TEAM_CUMULATED_OVERTIME_THRESHOLD: "Schwellenwert für die Überstunden-Balance",
    EMPLOYEE_ACCEPTED_OVERTIME_THRESHOLD: "Schwellenwert für akzeptierte Überstunden",
    EMPLOYEE_REPORTED_OVERTIME_THRESHOLD: "Schwellenwert für gemeldete Überstunden",
    EMPLOYEE_CUMULATED_OVERTIME_THRESHOLD: "Schwellenwert für die Überstunden-Balance",
    SEND_AT_MONTH_DAY: "Bericht an jeden",
    SEND_AT: "Senden am",
    EVERY_DAY: "Kalendertag des Monats senden",
    LANGUAGE: "Sprache",
    TEAM: "Team",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    SEND_SUBSCRIPTION: "Mitteilung senden",
    TEAM_ROWS: "Maximale Zeilen",
    EMPLOYEE_ROWS: "Maximale Zeilen"
  },
  OVERTIME_APPLICATION: {
    OVERTIME_APPLICATION: "Überstundenantrag",
    CONFIRM_DELETE: "Wollen Sie die Antragsnummer wirklich löschen?",
    CONFIRM_ACCEPT: "Wollen Sie die Antragsnummer annehmen",
    YES: "Ja",
    APPLICATIONS_WAITING_FOR_ACCEPTANCE: "Ausstehende Anträge",
    ACCEPTED_APPLICATIONS: "Akzeptierte Anträge",
    REQUESTED_CHANGES: "Angefragte Änderungen",
    STARTED_APPLICATIONS: "Offene Anträge",
    FINISHED_AND_REJECTED_APPLICATIONS: "Bearbeitete und abgelehnte Anträge",
    SETTLED_APPLICATIONS: "Abgeschlossene Anträge",
    SETTLE_REQUEST: "Antrag abschließen",
    POSSIBLE_TIME: "Moegliche Zeit zum Abschließen",
    USE_ALL: "Alle Zeit verwenden",
    POSSIBLE_TIME_IS_SMALLER: "Moegliche Zeit ist kleiner als die Zeit zum Abschließen",
    TIME_TO_SETTLE_TOO_SMALL: "Zeit zum Abschließen ist zu klein",
    TABLE: {
      FROM: "Von",
      TO: "Bis",
      NEW_APPLICATION: "Neuen Antrag hinzufügen",
      APPLICATION_CODE: "Antragsnummer",
      CLIENTS: "Mandant(en)",
      DURATION: "Dauer",
      REPORTED_TIME: "Berichtete Zeit",
      LAST_COMMENT: "Letzter Kommentar",
      STATUS: "Status",
      VIEW: "Anzeigen",
      ACCEPT: "Akzeptieren",
      EDIT: "Bearbeiten",
      REQUEST_CHANGES: "Änderungen anfragen",
      ALLOCATE: "Zuordnen",
      SETTLE: "Abschließen",
      NO_APPLICATIONS: "Keine Anträge",
      EMPLOYEE: "Mitarbeiter",
      COMPLETED_NEGATIVELY_TOOLTIP: "Zu diesem Überstundenantrag wurde keinen Worklog zugeordnet",
      REJECT: "Ablehnen",
      SETTLE_TOOLTIP: "Um diesen Antrag zu abschließen, musst du den Teamleiter oder Manager kontaktieren",
      NO_EMPLOYEES: "Keine Mitarbeiter zuordnen",
    },
    FORM: {
      NEW_APPLICATION: "Neuer Antrag",
      FROM: "Von",
      FROM_ERROR: 'Wert "Von" ist ungültig. Der erste verfügbare Termin ist ',
      TO: "Bis",
      TO_ERROR: 'Die Angabe "Bis" darf nicht vor der Angabe "Von" beginnen',
      DURATION: "Dauer",
      FOR_EMPLOYEE: "Für Mitarbeiter",
      APPROVERS: "Annehmer",
      CLIENTS: "Mandant(en)",
      COMMENT: "Kommentar",
      COMMENTS_HISTORY: "Verlauf der Kommentare:",
      REQUEST_CHANGES: "Änderungen anfragen",
      SEND: "Senden"
    },
    STATUS_TYPES: {
      NEW: "Neu",
      SENT: "Gesendet",
      TO_ACCEPT: "Zu akzeptieren",
      ACCEPTED: "Akzeptiert",
      UPDATE_DONE: "Update gemacht",
      REQUESTED_UPDATE: "Update angefordert",
      NEW_UPDATE: "Neues Update",
      COMPLETED_PARTIALLY: "Teilweise bearbeitet",
      COMPLETED_POSITIVELY: "Erfolgreich bearbeitet",
      COMPLETED_NEGATIVELY: "Antrag abgelehnt",
      ALLOCATED_PARTIALLY: "Teilweise zugeordnet",
      ALLOCATED: "Zugeordnet",
      REJECTED: "Abgelehnt"
    },
    LAST_UPDATE_ERROR: "Diesem Überstundenantrag wurde in der Zwischenzeit aktualisiert. Aktualisieren Sie die Seite und sehen Sie, was sich geändert hat."
  },
  LEGAL_RULES: {
    TITLE: "Gesetzliche Regelungen",
    NEW: "Neue gesetzliche Konfiguration hinzufügen",
    LEGAL_OVERTIME_RULES: "Gesetzliche Überstundenregelung",
    MON: "Mo",
    TUE: "Di",
    WED: "Mi",
    THU: "Do",
    FRI: "Fr",
    SAT: "Sa",
    SUN: "So",
    HOLIDAY_THRESHOLD: "Urlaub",
    SUBSCRIPTION_USERS: "Empfänger",
    VALID_FROM: "Gültig ab",
    DELETE: "Löschen",
    DELETE_LEGAL_OVERTIME_RULES: "Gesetzliche Überstundenregelungen löschen",
    EDIT: "Bearbeiten",
    LEGAL_RULES_ALERT: "Benachrichtung für gesetzliche Regelungen",
    CONFIRM_ADDITION: "Möchten Sie eine Benachrichtung für gesetzliche Überstunden für {{user}} einrichten?",
    LANGUAGE: "Sprachen",
    DEFINE: "Legen Sie für jeden Tag und für die Feiertage ein Zeitlimit für die Arbeit fest.",
    DEFINE_TOOLTIP: 'Die angegebene Stundenzahl entspricht dem Tageslimit der gemeldeten Arbeitszeit. Das Limit kann an jedem Tag variieren - Benachrichtungen werden auf der Grundlage der angegebenen Stundenzahl gesendet. Wenn die Benutzer an einem bestimmten Tag nicht arbeiten sollten, tragen Sie bitte "0" in die Lücke ein.',
    SUBSCRIPTIONUSERS_TOOLTIP: "Bitte wählen Sie die Benutzer aus, an die Benachrichtigungen über ihre Mitarbeiter gesendet werden sollen."
  },
  USERSUBSANDALERTS: {
    TITLE: "Mitteilungen und Benachrichtungen",
    USER_NAME: "Vollständiger Name",
    USER_TEAM_NAME: "Teamname",
    ROLE: "Funktion",
    OVERTIME_SUBSCRIPTION: "Überstunden",
    PROFITABILITY_SUBSCRIPTION: "Rentabilität",
    WORKTIME_SUBSCRIPTION: "Benachrichtigungen über gesetzliche Überstunden",
    VIEW: "Anzeigen",
    ADD: "Neue hinzufügen",
    OVERTIME_APPLICATION_SUBSCRIPTION: "Überstundenanträge"
  },
  SUBORDINATE_TEAMS: {
    TITLE: "Subordinate teams",
    NAME: "Team name",
    MAIN: "Main",
    ACTIVE: "Active",
    ACTIVATE: "Activate",
    DEACTIVATE: "Deactivate",
    ARCHIVED: "Archived"
  },
  NOTES: {
    TITLE: "Notes",
    CLIENT_NOTE: "Einrichtung des Mandanten und Informationen zur Organisation"
  },
  AUTOMATION_DASHBOARD: {
    TITLE: "Automation dashboard",
    AUTOMATION_NAME: "Technology",
    NEW: "Add new technology",
    EXPORT: "Export",
    HISTORIC_EXPORT: "Historic export",
    EDIT: "Edit",
    DELETE: "Delete",
    HISTORIC_EXPORT_CHANGES: "Historic changes export"
  },
  TECHNOLOGY: {
    NEW_TECHNOLOGY: "New technology",
    AUTOMATION_NAME: "Name",
    EDIT_TECHNOLOGY: "Edit technology",
    DELETE_TECHNOLOGY: "Delete technology",
    HISTORIC_EXPORT: "Historic export",
    HISTORIC_CHANGES_EXPORT: "Historic changes export",
    FROM: "Pick date from",
    TO: "to"
  },
  BILLING_TYPE: {
    TITLE: "Billing type",
    ADD_NEW: "Add new billing type",
    NEW_BILLING_TYPE: "New billing type",
    NAME: "Name",
    COUNTRY: "Country",
    BILLING_TYPE: "Billing type",
    EDIT: "Edit",
    DELETE: "Delete",
    EDIT_BILLING_TYPE: "Edit billing type",
    DELETE_BILLING_TYPE: "Delete billing type"
  },
  OVERTIME_REQUESTS_ALERT: {
    ADD_SUBSCRIPTION: "Überstundenanforderung hinzufügen",
    EDIT_SUBSCRIPTION: "Überstundenanforderung bearbeiten",
    DELETE_SUBSCRIPTION: "Überstundenanforderung löschen",
    LANGUAGE: "Sprache",
    TEAM_ID: "Team",
    ALL_TEAMS: "Alle Teams"
  },
  D365: {
    D365: "D365",
    CLIENT_D365: "Mandant (D365)",
    TAX_ID_KLIX: "Tax ID (KliX)",
    CLIENT_KLIX: "Mandant (KliX)",
    CLIENTS_KLIX: "Mandanten in KliX",
    NO_CLIENTS: "In diesem Land gibt es keine Mandanten",
    CLIENTS_CONFIG: "Mandanten",
    PG_CONFIG: "Prozesse",

    INTERRUPTS: "Unterbrechungen",
    INTERRUPT_KLIX: "Unterbrechung (KliX)",
    D365_PROCESS_GROUP: "D365-Prozessgruppe",
    PROCESS_GROUPS: "Prozessgruppen in KliX",
    PROCESS_GROUP_KLIX: "Prozessgruppe (KliX)",
    EXCEPTIONS: "Ausnahmen",
    ADD_EXCEPTION: "Ausnahme hinzufügen",
    PROCESS_FOR_PG: "Prozess für Prozessgruppe",
    EDIT: "Bearbeiten",
    DELETE: "Löschen",
    SELECT_PROCESS_GROUPS: "Prozessgruppe auswählen",
    SELECT_PROCESS: "Prozess auswählen",
    PROCESS: "Prozess",
    PROCESS_KLIX: "Prozess (KliX)",
    WBS_ELEMENT: "WBS-ELEMENT (D365)",
    PG_INACTIVE: "Dieser Prozessgruppe ist in D365 inaktiv.",
    PROCESS_INACTIVE: "Dieser Prozess ist in D365 inaktiv.",
    CLIENT_SEARCH_PLACEHOLDER: "Geben Sie mindestens 3 Zeichen ein, um automatisch zu suchen, oder drücken Sie die Eingabetaste, um eine Suche zu erzwingen",
    CLIENT_SEARCH_TOOLTIP: "Je kürzer die Zeichenfolge (oder die Lücke), desto länger dauert die Suche bis zu mehreren Minuten",
    NO_INTERRUPTS_WITHOUT_CLIENT: "In diesem Land gibt es keine Unterbrechungen ohne Kunden",
    NO_INTERRUPTS_WITH_CLIENT: "Es gibt keine Unterbrechungen mit Kunden in diesem Land",
    INTERRUPTS_WITHOUT_CLIENT: "Unterbrechungen ohne Client",
    INTERRUPTS_WITH_CLIENT: "Unterbrechungen mit dem Kunden",
    INTERRUPT_D365: "WBS-ELEMENT (D365)",
    INTERRUPT_SEARCH_PLACEHOLDER: "Geben Sie mindestens 3 Zeichen ein, um automatisch zu suchen, oder drücken Sie die Eingabetaste, um eine Suche zu erzwingen",
    INTERRUPT_SEARCH_TOOLTIP: "Je kürzer die Zeichenfolge (oder die Lücke), desto länger dauert die Suche bis zu mehreren Minuten",
  },
  PROFIT_CENTER: {
    TITLE: "Profit center",
    ADD_NEW_PROFIT_CENTER: "Add new profit center",
    NEW_PROFIT_CENTER: "New profit center",
    NAME: "Name",
    COUNTRY: "Country",
    EDIT: "Edit",
    DELETE: "Delete",
    EDIT_PROFIT_CENTER: "Edit profit center",
    DELETE_PROFIT_CENTER: "Delete profit center",
    SEARCH: "Search",
    CODE:"Code",
    DESCRIPTION:"Description"
  },
  SENIORITY_LEVELS: {
    TITLE: "Levels",
    EDIT_SENIORITY_LEVELS: "Edit levels",
    L01: "L01 - non-Fee-Earner",
    L02: "L02 - Associate",
    L03: "L03",
    L04: "L04 - Senior Associate",
    L05: "L05",
    L06: "L06 - Manager",
    L07: "L07",
    L08: "L08 - Associate Partner",
    L09: "L09",
    L10: "L10 - Partner / Equity Partner / Shareholder"
  },
  REPORTS: {
    TITLE: "Reports",
    ADD: "Add new report",
    NEW_REPORT: "New report",
    REPORT: "Type",
    NAME: "Name",
    REPORT_COUNTRIES: "Countries",
    SEND_AT_MONTH_DAY: "Send a report on every",
    EVERY_DAY: "day of the month",
    LANGUAGE: "Language",
    SEND_FREQUENCY: "Frequency",
    REPORT_DETAILS: "Report details",
    ROLE: "Role",
    TEAM: "Team",
    SITE: "Site",
    PROFIT_CENTER: "Profit center",
    ACTIVE_FROM: "Active from",
    MONTHLY: "1 month",
    QUARTERLY: "3 months",
    YEARLY: "12 months",
    GROUPED_USERS: "Invoicing Report",
    USERS: "Users Report",
    EMAIL_ADDRESSES: "E-mails",
    USERS_NUMBER: "Amount of users",
    SEND_AT: "Send at",
    FREQUENCY: "Send frequency",
    COUNTRY: "Country",
    EMAILS: "E-mails",
    SEARCH: "Search",
    EDIT: "Edit",
    EDIT_REPORT: "Edit report",
    DELETE: "Delete",
    DELETE_REPORT: "Delete report",
    SEND_REPORT: "Send report",
    REPORT_TYPE: "Type",
    EXCLUDED_TEAMS: "Excluded Teams",
    EXCLUDED_TEAMS_INFO: "Excluded Teams"
  }
};
